<template>
	<div class="applicationDiscount">
		<div class="main_width m0a">
			<div class="topper pl36 fStart aifs mt38 mb25">
				<div class="item_logo_a"></div>
				<!--进度条-->
				<Steps :current="current" class="tl fl step_style">
					<Step title="" content="提交承兑汇票信息"></Step>
					<Step title="" content="获取报价选择贴入行"></Step>
					<Step title="" content="操作网银贴现"></Step>
					<Step title="" content="贴现成功银行回款"></Step>
				</Steps>
			</div>

			<div v-if="code == 1" class="mb16">
				<div class="bbe6e6e6 bgfff bs2 mb20 pb80 ticketStyle">
					<Tabs value="name1" @on-click="initTip">
						<TabPane :label="label" name="name1" class="pr p40 pb30 df jca">
							<div class="mr40">
								<div class="c999 mb20 tl">承兑汇票图片（正面）</div>
								<div class="divOcrImg pr">
									<div
										class="df fDC aic jcc pr h100b img_left cp"
										@click="uploadImg('ticket')"
									>
										<p class="fb l25 f24 c8FA4C8">银行承兑汇票</p>
										<p class="fb f16 mt93 c333">点击此处上传票面图片</p>
										<p class="c6C819B f14 mb30">(网银截图／清晰的照片)</p>

										<input
											ref="upload_file"
											type="file"
											class="upload-file dn"
											@change="getFile($event, 'aupUrlA')"
										/>
									</div>
									<div
										class="pa left0 t0 w100b h100b bscontain bimginitial bg000"
										v-if="allParam.billBase64"
										:style="{
											backgroundImage: 'url(' + allParam.billBase64 + ')',
										}"
									></div>

									<div class="pa t11 r10 zi2" v-if="allParam.billBase64">
										<Button
											type="info"
											class="ml10"
											@click="viewerExampleShow('base64Img')"
											>查看大图</Button
										>
										<img
											ref="base64Img"
											id="base64Img"
											style="display:none;"
											:src="allParam.billBase64"
										/>
										<Button
											type="primary"
											class="ml10"
											@click.stop="uploadImg('ticket')"
											>重新上传</Button
										>
									</div>

									<div class="pa t11 r10 zi2" v-else>
										<Button
											type="info"
											icon="ios-search"
											@click="viewerExampleShow('exampleImg')"
											>查看示例</Button
										>
										<img
											ref="exampleImg"
											id="exampleImg"
											style="display:none;"
											src="~@/assets/img/applicationDiscount/tU_b@2x.png"
										/>
									</div>

									<div class="ocrLodingAnimateBg" v-if="code1Param.ocrLoading">
										<div class="ocrLodingAnimate"></div>
									</div>

									<!-- <Spin fix v-if="code1Param.ocrLoading">
                    <div class="p10 br4 bg0006">
                      <Icon type="ios-time" class="dp-c-waite f46" />
                      <div class="fb f16 cfff">票面信息识别中</div>
                    </div>
                  </Spin> -->
								</div>
							</div>
							<div class="f1">
								<div class="df jcb mb20">
									<span class="c999">承兑汇票信息</span>
									<span
										v-if="code1Param.msgTip"
										:class="[code1Param.msgTipCss]"
										>{{ code1Param.msgTip }}</span
									>
								</div>
								<div class="right_ticket_img">
									<div class="df aic  pr">
										<span class="dl w76 tl c666 f16">票号</span>
										<div v-if="code1Param.ocrLoading" class="pr f1">
											<Input placeholder="识别中" disabled class="f1" />
											<Icon
												type="ios-loading"
												size="15"
												class="demo-spin-icon-load demo-spin-icon-load-position"
											></Icon>
										</div>
										<div v-else-if="allParam.billBase64" class="pr f1">
											<Input
												:class="allParam.billNoTip ? 'error_input' : ''"
												v-model="allParam.billNo"
												placeholder="请输入票号"
												@keyup.native="billNoNumber"
												@on-blur="blurNoNum"
												class="f1"
												maxlength="30"
											/>
											<Button
												class="pa r5 t50b"
												v-if="!billSubStatus"
												size="small"
												@click="billSubStatus = true"
												>添加子票区间</Button
											>
										</div>
										<Input
											v-else
											placeholder="请先上传票面图片，信息将自动识别"
											disabled
											class="f1"
										/>
										<span
											v-if="allParam.billNoTip"
											class=""
											style="position: absolute; top: 34px; left: 76px; color: red;"
											>票号不满30位</span
										>
									</div>
									<div class="df aic mb20 pr mt20" v-if="billSubStatus">
										<div class="fStart f12 aic ml76">
											<span>子票编号（无则不填）</span>
											<Input
												class="w120"
												size="small"
												v-model="billSubNo1"
												maxlength="12"
												v-number-only
											></Input>
											<span class="ml10 mr10">--</span>
											<Input
												class="w120"
												size="small"
												v-model="billSubNo2"
												maxlength="12"
												v-number-only
											></Input>
										</div>
									</div>
									<div class="df aic jcb mb30 mt30">
										<div class="w100b df aic pr">
											<span class="dl w76 tl c666 f16">票面金额</span>
											<div v-if="code1Param.ocrLoading" class="pr f1">
												<Input placeholder="识别中" disabled class="f1" />
												<Icon
													type="ios-loading"
													size="15"
													class="demo-spin-icon-load demo-spin-icon-load-position"
												></Icon>
											</div>
											<Input
												v-else-if="allParam.billBase64"
												v-model="allParam.billAmount"
												placeholder="请输入票面金额"
												@keyup.native="billAmountNumber"
												class="f1"
												maxlength="12"
											/>
											<Input
												v-else
												placeholder="请先上传票面图片，信息将自动识别"
												disabled
												class="f1"
											/>
											<span
												v-if="!code1Param.ocrLoading"
												class="pa r5 c0077DA t5"
												>{{ allParam.billAmountSupper }}</span
											>
										</div>
									</div>
									<div class="df aic jcb mb30">
										<div class="w100b df aic pr">
											<span class="dl w76 tl c666 f16">到期日</span>
											<div v-if="code1Param.ocrLoading" class="pr f1">
												<Input placeholder="识别中" disabled class="f1" />
												<Icon
													type="ios-loading"
													size="15"
													class="demo-spin-icon-load demo-spin-icon-load-position"
												></Icon>
											</div>
											<DatePicker
												v-model="allParam.dueDate"
												:editable="false"
												v-else-if="allParam.billBase64"
												type="date"
												placement="top-start"
												placeholder="请选择到期日"
												class="f1"
												@on-change="queryDayByDate"
											></DatePicker>
											<Input
												v-else
												placeholder="请先上传票面图片，信息将自动识别"
												disabled
												class="f1"
											/>
											<span
												class="pa r30 c666 t5"
												v-if="allParam.dueDate && !code1Param.ocrLoading"
												>距到期日{{ allParam.dueDays }}</span
											>
										</div>
									</div>
									<div class="df aic jcb mb30">
										<div class="w100b df aic pr">
											<span class="dl w76 tl c666 f16">承兑人</span>
											<div v-if="code1Param.ocrLoading" class="pr f1">
												<Input placeholder="识别中" disabled class="f1" />
												<Icon
													type="ios-loading"
													size="15"
													class="demo-spin-icon-load demo-spin-icon-load-position"
												></Icon>
											</div>
											<Input
												:class="
													allParam.acceptorBankNumTip ? 'error_input' : ''
												"
												v-else-if="allParam.billBase64"
												v-model="
													allParam.acceptorBankName || allParam.acceptorBankNum
												"
												placeholder="请输入承兑人行号"
												@keyup.native="acceptorBankNumNumber"
												class="f1"
												maxlength="12"
												@on-focus="allParam.acceptorBankName = ''"
												@on-blur="blurBank"
											/>
											<Input
												v-else
												placeholder="请先上传票面图片，信息将自动识别"
												disabled
												class="f1"
											/>
											<span
												v-if="allParam.acceptorBankNumTip"
												class=""
												style="position: absolute; top: 34px; left: 76px; color: red;"
												>承兑行不满12位</span
											>
										</div>
									</div>
								</div>
							</div>
						</TabPane>

						<!-- <TabPane :label="label1" name="name2" :disabled="!isTabTrue" class="p40 pb30 df jca"> -->
						<TabPane :label="label1" name="name2" class="pr p40 pb30 df jca">
							<div class="mr40">
								<div class="c999  mb20 tl">填写示例</div>
								<div class="df fDC aic jcc pr ticket_example"></div>
							</div>
							<div class="f1">
								<div class="df jcb mb20">
									<span class="c999">请填写承兑汇票信息</span>
								</div>
								<div class="right_ticket_img">
									<div class="df aic  pr">
										<span class="dl w76 tl c666 f16">票号</span>
										<Input
											:class="allParam.billNoTip ? 'error_input' : ''"
											v-model="allParam.billNo"
											placeholder="请输入票号"
											@keyup.native="billNoNumber"
											@on-blur="blurNoNum"
											class="f1"
											maxlength="30"
										/>
										<span
											v-if="allParam.billNoTip"
											class=""
											style="position: absolute; top: 34px; left: 76px; color: red;"
											>票号不满30位</span
										>
										<Button
											class="pa r5 t50b"
											v-if="!billSubStatus"
											size="small"
											@click="billSubStatus = true"
											>添加子票区间</Button
										>
									</div>
									<div class="df aic mb20 pr mt20" v-if="billSubStatus">
										<div class="fStart f12 aic ml76">
											<span>子票编号（无则不填）</span>
											<Input
												class="w120"
												size="small"
												v-model="billSubNo1"
												maxlength="12"
												v-number-only
											></Input>
											<span class="ml10 mr10">--</span>
											<Input
												class="w120"
												size="small"
												v-model="billSubNo2"
												maxlength="12"
												v-number-only
											></Input>
										</div>
									</div>
									<div class="df aic jcb mb30 mt30">
										<div class="w47b df aic">
											<span class="dl w76 tl c666 f16">票面金额</span>
											<Input
												v-model="allParam.billAmount"
												placeholder="请输入票面金额"
												@keyup.native="billAmountNumber"
												class="f1"
												maxlength="12"
											/>
										</div>
										<div class="w47b df aic">
											<span class="dl w76 tl c666 f16">大写金额</span>
											<Input
												v-model="allParam.billAmountSupper"
												placeholder="---"
												class="f1"
												disabled
											/>
										</div>
									</div>
									<div class="df aic jcb mb30">
										<div class="w47b df aic">
											<span class="dl w76 tl c666 f16">到期日</span>
											<DatePicker
												v-model="allParam.dueDate"
												type="date"
												placement="top-start"
												placeholder="请选择到期日"
												@on-change="queryDayByDate"
												class="f1"
											></DatePicker>
										</div>
										<div class="w47b df aic">
											<span class="dl w76 tl c666 f16">计息天数</span>
											<Input
												v-model="allParam.dueDays"
												placeholder="---"
												class="f1"
												disabled
											/>
										</div>
									</div>
									<div class="df aic jcb mb30 pr">
										<span class="dl w76 tl c666 f16">承兑人</span>
										<div class="f1 pr">
											<Input
												:class="
													allParam.acceptorBankNumTip ? 'error_input' : ''
												"
												v-model="
													allParam.acceptorBankName || allParam.acceptorBankNum
												"
												placeholder="请输入承兑人行号"
												@keyup.native="acceptorBankNumNumber"
												maxlength="12"
												@on-focus="allParam.acceptorBankName = ''"
												@on-blur="blurBank"
											/>
										</div>
										<span
											v-if="allParam.acceptorBankNumTip"
											class=""
											style="position: absolute; top: 34px; left: 76px; color: red;"
											>承兑行不满12位</span
										>
									</div>
								</div>
							</div>
						</TabPane>
					</Tabs>

					<Button
						class="f16 w268 hl45 p0"
						@click="nextBtnEvent"
						:disabled="!code1Param.nextStatus"
						:class="[code1Param.nextStatus ? 'btnDiscountBg' : 'btnDisable']"
					>
						<svg-icon
							class="va-4 mr5 f20"
							icon-class="Cloud_computing"
						></svg-icon
						>下一步，获取银行报价
					</Button>
				</div>

				<img
					v-if="bottomImg && bottomImg.picName"
					@click="toLinkUrl(bottomImg.linkUrl)"
					class="cp"
					:src="getImgUrl(bottomImg.picName)"
					width="100%"
					alt=""
				/>
			</div>

			<div v-if="code == 11" class="mb16">
				<div class="h652 bgfff dCC mb20">
					<div class="code2Loading df aic">
						<p class="iconBankKtb"></p>
						<p class="code2LoadingAnimate"></p>
						<p class="iconBankAll"></p>
					</div>
					<p class="f24 fb mt10 mb5">正在向银行请求贴现</p>
					<p class="f20">请您耐心等待…</p>
				</div>

				<img
					v-if="bottomImg && bottomImg.picName"
					@click="toLinkUrl(bottomImg.linkUrl)"
					class="cp"
					:src="getImgUrl(bottomImg.picName)"
					width="100%"
					alt=""
				/>
			</div>

			<div v-if="code == 2" class="bs2 mb20">
				<!--顶部票面信息展示-->
				<div class="df jca aic top_img h151">
					<Table
						tooltip-theme="dark"
						class="f1 ml185 mr24 l24 top"
						:columns="code2Param.table1.columns14"
						:data="code2Param.table1.data5"
						border
						:span-method="handleSpan"
						:show-header="code2Param.table1.header"
						size="small"
					>
						<template slot-scope="{ row }" slot="name">
							<div class="c999 f14">{{ row.name }}</div>
						</template>
						<template slot-scope="{ row }" slot="key">
							<div class=" f14">{{ row.key }}</div>
						</template>
						<template slot-scope="{ row }" slot="sum">
							<div class="c999 f14">票面金额</div>
							<div class="f14 dp-c-important fb">
								￥<span class="f24">{{ row.billAmount }}</span
								><span class="c333">（{{ row.billAmountSupper }}）</span>
							</div>
						</template>
					</Table>
					<Button type="info" class="mr40" ghost @click="reUpload()"
						>重新上传</Button
					>
				</div>

				<!--选择贴现行-->
				<div class="plr40 ptb20 bgfff">
					<div class="df jcb aic mb20">
						<span class="tl fb f14 ">请选择贴入行</span>

						<div class="df">
							<div class="calculatorBg pr">
								<p class="title">
									<Icon class="icon1" type="ios-information-circle" /><span
										class="text"
										>贴现利息怎么计算？</span
									>
								</p>

								<div>
									<p class="title">
										<span class="icon">1</span
										><span class="text">应付贴息是如何计算的？</span>
									</p>
									<div class="box1 df jcc aic f18 fb">
										<p class="c343434">票面金额</p>
										<p class="c9A9A9A mw50">×</p>
										<div class="pr interest">
											<p class="bgCCFDE1">年化利率%</p>
											<div class="pa f12 bgCCFDE1">
												<p class="c666">票据贴现的计息方式，按照年化进行计算</p>
												<p class="cE21F13">区别于传统借贷的日息与月息</p>
											</div>
										</div>
										<p class="c9A9A9A mw50">×</p>
										<div class="pr day">
											<p class="bgD6E6FF">计息天数</p>
											<hr class="bg333" />
											<p>360</p>
											<div class="pa f12 bgD6E6FF">
												<p class="c333">计息天数为“贴现日”至“兑付日”的天数差</p>
												<p class="c666">（通常计算时以当日作为“贴现日”）</p>
											</div>
										</div>
										<p class="c9A9A9A mw50">＝</p>
										<p class="c343434">应付贴息</p>
									</div>
									<hr />
									<p class="title mb20">
										<span class="icon">2</span
										><span class="text">贴现后所得金额是如何计算的？</span>
									</p>
									<div class="df jcc aic f18 fb">
										<p class="c343434">票面金额</p>
										<p class="c9A9A9A mw50">﹣</p>
										<p class="c005FFF">应付贴息</p>
										<p class="c9A9A9A mw50">＝</p>
										<p class="c343434">贴现后所得金额</p>
									</div>
								</div>
							</div>

							<Checkbox
								class="checkBoxDisabledStyle ml65"
								v-model="code2Param.rateBtn"
								disabled
								>利率从低到高排序</Checkbox
							>
						</div>
					</div>

					<div class="bank_list_ul">
						<div
							class="bank_list_li bccc df aic jcb pl23 pr40 ptb10 mb20"
							:class="[handleDiscountStatus(item) ? '' : 'bgf6f6f6 ']"
							v-for="(item, index) in code2Param.discountBankList"
							:key="item.id"
						>
							<div class="df aic jcfs mw150">
								<i
									class="bscontain bank_img dl wh26 mr10"
									:style="logoStyle(item.bankCode)"
								></i>

								<!-- <span class="fb" :class="[handleDiscountStatus(item) ? 'f18' : 'c999']">{{item.bankName}}</span> -->
								<div class="fCStart ">
									<span
										class="fb tl"
										:class="[handleDiscountStatus(item) ? 'f18' : 'c999']"
										>{{ item.bankName }}</span
									>
									<!-- 增加银行信息说明 -->
									<!-- <Tooltip v-if="item.bankInfoStr && item.bankInfoStr.length >= 18" :content="item.bankInfoStr" placement="bottom" max-width="100%" class="tool-tip-s">
                    <span class="db maxw130 tl otw c7f7f7f f13">{{item.bankInfoStr}}</span>
                  </Tooltip> -->
									<!-- <span class="db maxw130 tl otw cp c7f7f7f f13 bankInfo" v-else-if="item.bankInfoStr">{{item.bankInfoStr}}</span> -->
									<div class="db  bankInfo pr" v-if="item.bankInfoStr">
										<span
											class="maxw90 tdl-underline dl tl otw cp c7f7f7f f13"
											>{{ item.bankInfoStr }}</span
										>
										<div class="bankInfoPopover">
											<div class="bankInfoPopover-top  fStart pr oh">
												<div
													class="w100 h100 mr13"
													v-if="getBnkInfoBg(item.bankCode)"
												>
													<img :src="getBnkInfoBg(item.bankCode)" alt="" />
												</div>
												<div class="w397">
													<p class="fb c333 tl">{{ item.bankName }}</p>
													<p class="f12 c666 tl">{{ item.bankInfoStr }}</p>
												</div>
												<i
													class="bscontain bank_img dl w134 h134 pa t-27 r-17 opt008"
													:style="logoStyle(item.bankCode)"
												></i>
											</div>
											<div class="bankInfoPopover-bottom fStart p14">
												<div class="w110 tl">贴现受理时间</div>
												<div class="w78b c999">
													<div class="fSpace ">
														<span class="fStart "
															><span class="dl w60 tl">工作日</span>:</span
														>
														<div
															class="jCEnd fW c666"
															v-if="
																$store.state.publicData.acceptorWorkTime[
																	item.bankCode
																].workInfo
															"
														>
															<div
																v-for="(item, index) in $store.state.publicData
																	.acceptorWorkTime[item.bankCode].workInfo"
																:key="index"
															>
																<div v-html="item.desHtml" class="ml10"></div>
																<!-- <div class="more" v-if="false">
                                  详情&nbsp;>
                                  <div class="more_detail bs2" v-html="item.more"></div>
                                </div> -->
															</div>
														</div>
														<span v-else></span>
													</div>
													<div
														class="fSpace mt10"
														v-if="
															$store.state.publicData.acceptorWorkTime[
																item.bankCode
															].holidayInfo &&
																$store.state.publicData.acceptorWorkTime[
																	item.bankCode
																].holidayInfo.length > 0
														"
													>
														<span class="fStart "
															><span class="dl w60 tl ">非工作日</span>:</span
														>
														<div class="jCEnd fW c666">
															<div
																v-for="(item, index) in $store.state.publicData
																	.acceptorWorkTime[item.bankCode].holidayInfo"
																:key="index"
																v-html="item.desHtml"
																class="ml10"
															></div>
														</div>
													</div>
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>

							<div class="df aic jcc f1" v-if="item.isQueryRate">
								<!--银行贴现利率-->
								<div class="be9e9e9 tl w640 mr40">
									<div class="hl40 bbe9e9e9 df plr20">
										<div class="w25b c999">贴现年化利率</div>
										<div class="w25b c999">每十万支付利息</div>
										<div class="w25b c999">总计支付利息</div>
										<div class="w25b c999">贴现后到账金额</div>
									</div>

									<div
										class="hl40 df plr20 fb"
										v-if="handleDiscountStatus(item)"
									>
										<div class="w25b">
											<span class="f18">{{
												item.realDiscountRate || item.activDiscountRate
													? Number(
															item.realDiscountRate || item.activDiscountRate
													  ).mul(100)
													: ""
											}}</span
											>%
										</div>
										<div class="w25b">
											¥<span class="f18">{{
												item.activProfit
													? formatMoney(item.activProfit, 2, "")
													: "---"
											}}</span>
										</div>
										<div class="w25b">
											¥<span class="f18">{{
												item.activInterest
													? formatMoney(item.activInterest, 2, "")
													: "---"
											}}</span>
										</div>
										<div class="w25b dp-c-important">
											¥<span class="f18">{{
												item.realDiscountAmount || item.activDiscountAmount
													? formatMoney(
															item.realDiscountAmount ||
																item.activDiscountAmount,
															2,
															""
													  )
													: "---"
											}}</span>
										</div>
									</div>
									<div class="hl40 df plr20 ccc f18" v-else>
										<div class="w25b">---</div>
										<div class="w25b">---</div>
										<div class="w25b">---</div>
										<div class="w25b">---</div>
									</div>
								</div>

								<!--操作按钮-->
								<div class="df fDC" v-if="handleDiscountStatus(item)">
									<Button
										type="error"
										ghost
										class="w110 mb10"
										size="small"
										v-if="item.discountActivityInfo"
										>{{ item.discountActivityInfo }}</Button
									>
									<template v-if="item.status == 10">
										<Button
											type="primary"
											class="w110"
											@click="nextBtnEvent(item)"
											v-if="item.bankCode === 'HUARUN'"
											>立即贴现</Button
										>
										<Button
											type="primary"
											class="w110"
											@click="nextBtnEvent(item)"
											v-else-if="item.bankCode !== 'FM'"
											>立即贴现</Button
										>
										<template v-else>
											<Button
												type="primary"
												class="w110"
												@click="uploadFMTip('CUSTOMER_SERVICE')"
												v-if="item.bankUpgradeType === 'CUSTOMER_SERVICE'"
												>立即升级</Button
											>
											<Button
												type="primary"
												class="w110"
												@click="uploadFMTip('MYSELF')"
												v-else-if="item.bankUpgradeType === 'MYSELF'"
												>立即升级</Button
											>
											<Button
												type="primary"
												class="w110"
												@click="nextBtnEvent(item)"
												v-else
												>立即贴现</Button
											>
										</template>
									</template>
									<template v-else>
										<Button
											type="primary"
											class="w110"
											@click="showHuarunBankSignClick(item)"
											v-if="
												item.bankCode === 'HUARUN' &&
													code1Param.acctNormal.length > 0
											"
											>立即签约</Button
										>
										<Button
											type="primary"
											class="w110"
											@click="$router.push('/SilverTicketManage')"
											v-else
											>{{
												code1Param.acctNormal.length > 0
													? "立即签约"
													: "立即开户"
											}}</Button
										>
									</template>
								</div>

								<div v-else>
									<Button class="w110 c999" disabled>暂无授信</Button>
								</div>
							</div>

							<div class="df aic jcc pr h30 f1" style="flex: 1" v-else>
								<Spin fix>
									<span>询价中</span>
									<Icon
										type="ios-loading"
										size="18"
										class="demo-spin-icon-load"
									></Icon>
								</Spin>
							</div>
						</div>
					</div>
				</div>
			</div>

			<div v-if="code == 3" class="bs2 mb20 bgfff tl pr">
				<div class="pt20 plr40 pb40">
					<div class="dp-c-primary dp-bc-primary bbinitial mb35 f18 fb dl bw2">
						请核对信息
					</div>
					<div class="f16 fb mb20">
						贴现申请人：{{ allParam.discountAcctDto.corpName }}
					</div>
					<div class="df jcb">
						<div class="w457">
							<div class="mb20 c999">本次贴现承兑汇票信息</div>
							<div class="h370 p20 tl left_ticket_img1">
								<div class="bccc h100b df fDC jcc">
									<div class="df">
										<div class="w60 title_bg c666">
											<div class="brccc bbccc pl10 hl35">票号</div>
											<div class="brccc bbccc pl10 hl35">到期日</div>
											<div class="brccc bbccc pl10 hl35">承兑人</div>
										</div>
										<div class="f1">
											<div class="pl13 bbccc hl35">
												{{ allParam.discountData.billNo }}
											</div>
											<div class="pl13 bbccc hl35">
												{{ allParam.discountData.dueDate }}（计息{{
													allParam.discountData.dueDays
												}}）
											</div>
											<div class="pl13 bbccc hl35">
												{{
													allParam.discountData.acceptorBankName ||
														allParam.discountData.acceptorBankNum
												}}
											</div>
										</div>
									</div>
									<div class="df fDC jcc f1 pl30">
										<div class="c666 mb5 hl35">票面金额</div>
										<div class="hl35">
											<span class="dp-c-important fb">¥</span>
											<span class="f24 dp-c-important fb">{{
												formatMoney(allParam.discountData.billAmount, 2, "")
											}}</span>
											<span class="c0077DA"
												>（{{
													digitUppercase(allParam.discountData.billAmount)
												}}）</span
											>
										</div>
									</div>
								</div>
							</div>
						</div>

						<div class="w613">
							<div class="mb20 c999">贴现信息</div>
							<div class="h370 p20 right_ticket_img1">
								<div class="bccc h100b df fDC jcc tl">
									<div class="fStart">
										<div class="mw116 c666">
											<div class="bbccc pl10 brccc hl35 title_bg">贴入银行</div>
											<div class="bbccc h10"></div>
											<div class="bbccc pl10 brccc hl35 title_bg">
												贴现年化利率
											</div>
											<div class="bbccc pl10 brccc hl35 title_bg">
												总计支付利息
											</div>
										</div>
										<div class="w100b">
											<div class="bbccc f1 pl13 hl35">
												{{ allParam.discountData.bankName }}
											</div>
											<div class="bbccc h10"></div>

											<div class="df w100b bbccc hl35 hl35">
												<div class="w25b pl13 brccc">
													{{
														Number(
															allParam.discountData.realDiscountRate ||
																allParam.discountData.activDiscountRate
														).mul(100)
													}}%
												</div>
												<div class="w25b fStart">
													<div class="mw116 tc c666 brccc title_bg">
														折合每十万付息
													</div>
													<div class="w100b pl13">
														{{ formatMoney(allParam.discountData.activProfit) }}
													</div>
												</div>
											</div>

											<div class="bbccc f1 pl13 hl35">
												{{
													formatMoney(
														allParam.discountData.realDiscountAmount
															? allParam.discountData.billAmount -
																	allParam.discountData.realDiscountAmount
															: allParam.discountData.activInterest
													)
												}}
											</div>
										</div>
									</div>

									<div class="f1 df fDC jcc bbccc pl30">
										<div class="c666 mb10">贴现后可到账金额</div>
										<div>
											<span class="dp-c-important fb">¥</span>
											<span class="f24 dp-c-important fb">{{
												formatMoney(
													allParam.discountData.realDiscountAmount ||
														allParam.discountData.activDiscountAmount,
													2,
													""
												)
											}}</span>
											<span class="c0077DA"
												>（{{
													digitUppercase(
														allParam.discountData.realDiscountAmount ||
															allParam.discountData.activDiscountAmount
													)
												}}）</span
											>
										</div>
									</div>

									<div class="f1 df fDC jcc pl30">
										<div class="c666 mb18">回款预估</div>
										<div>
											<span>贴现成功后1分钟内回款至贴现账户</span>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
				<div class="btccc bgFBFBFB pl54 pr40 ptb18 df jcb">
					<!-- <div>
            <div class="df aic jcb">
              <div>
                <div class="c666 mb10">服务费</div>
                <div class="c999 mb10">贴现成功后收取服务费</div>
              </div>
              <Button type="primary" v-if="allParam.servicePrice < 0" @click="$router.push({name: 'DiscountTrends', params: {toRecharge: true}})">立即充值</Button>
            </div>
            <div class="df aic">
              <span class="fb">¥</span>
              <span class="f19 fb">{{formatMoney(allParam.discountData.serviceCharge, 2, '')}}</span>
              <span class="fb c666">（当前服务费余额 {{formatMoney($store.state.user.userInfo.balance)}}）</span>
              <div v-if="allParam.servicePrice < 0">
                <div class="dp-c-primary">服务费余额不足，请充值{{formatMoney(-allParam.servicePrice)}}元</div>
                <div class="hl12  cCA0B00">如贴现成功 本单为欠费订单</div>
              </div>
            </div>
          </div> -->
					<div v-if="isShowJDProcess">
						贸易背景审核结果：{{
							showJDProcessTextCode[
								allParam.discountData.discountSyncOrderJdDto.orderStatus
							]
						}}<Button class="ml10" @click="checkOrderInfo()">刷新</Button>
					</div>
					<div
						v-if="
							allParam.discountData.discountSyncOrderJdDto &&
								['10', '20', '40', '21', '30'].includes(
									allParam.discountData.discountSyncOrderJdDto.orderStatus || ''
								)
						"
						:class="['df', 'aic', isShowJDProcess ? '' : 'm0a']"
					>
						<Button
							type="primary"
							v-if="
								allParam.discountData.discountSyncOrderJdDto.orderStatus ===
									'40' && !isShowJDProcess
							"
							class="mr10"
							@click="JDInvoiceUploaded"
							>信息核对无误，上传贸易背景资料</Button
						>

						<Button
							type="primary"
							v-else-if="
								allParam.discountData.discountSyncOrderJdDto.orderStatus ===
									'40' && isShowJDProcess
							"
							class="mr10"
							@click="JDInvoiceUploaded"
							>重新上传贸易背景资料</Button
						>
						<Button
							type="primary"
							v-else-if="
								(allParam.discountData.discountSyncOrderJdDto.orderStatus ===
									'21' &&
									isShowJDProcess) ||
									['10', '30'].includes(
										allParam.discountData.discountSyncOrderJdDto.orderStatus
									)
							"
							class="mr10"
							@click="nextBtnEvent"
							>信息核对无误，开始贴现</Button
						>
						<Button
							type="primary"
							v-else-if="
								!isShowJDProcess &&
									(allParam.discountData.discountSyncOrderJdDto.orderStatus ===
										'21' ||
										allParam.discountData.discountSyncOrderJdDto.orderStatus ===
											'20')
							"
							class="mr10"
							@click="checkOrderInfo()"
							>已完成上传，查询审核结果</Button
						>
						<Button @click="reUpload()">取消贴现</Button>
					</div>
					<div class="df aic m0a" v-else>
						<Button
							type="primary"
							v-if="
								allParam.discountData.discountChannel === 'WHLH' ||
									allParam.discountData.discountChannel === 'fumin'
							"
							class="mr10"
							@click="nextBtnEvent"
							>下一步，完善贸易信息</Button
						>
						<Button type="primary" v-else class="mr10" @click="nextBtnEvent"
							>信息核对无误，开始贴现</Button
						>
						<Button @click="preBtnEvent">取消贴现</Button>
					</div>
				</div>

				<div
					class="h200 w100b bgFBFBFB pa b0 l0 bs-120 p20"
					v-if="isInvoiceUploaded"
				>
					<!-- <div class="h200 w100b bgFBFBFB pa b0 l0 bs-120 p20" v-if="true"> -->
					<p
						class="dp-c-primary "
						v-if="allParam.discountData.discountChannel === 'WHLH'"
					>
						应{{
							allParam.discountData.bankName
						}}监管要求，近期贴现需提交【至少上传1份合同/一张发票】<span
							class="f12 cp ml10 c0077DA tunder"
							@click="handleCustomerBtn"
							>不会上传？客服帮助</span
						>
					</p>
					<p class="dp-c-primary " v-else>
						应{{
							allParam.discountData.bankName
						}}监管要求，近期贴现需提交【票据上一手背书的合同及发票（至少一张）】<span
							class="f12 cp ml10 c0077DA tunder"
							@click="handleCustomerBtn"
							>不会上传？客服帮助</span
						>
					</p>
					<div class="fSpace aic mt10">
						<div class="fStart aifs">
							<div class="fStart aic">
								<p class="mr20">合同</p>
								<div class="dCC w130 h130 bccc agreement_bg">
									<div class="agreement">
										<div
											class="agreement_upload "
											v-if="
												discountRequirement.contract.filename &&
													discountRequirement.contract.filename.split(
														'.'
													)[1] === 'pdf'
											"
										></div>
										<img
											:src="discountRequirement.contract.fileUrl"
											alt=""
											v-else-if="
												discountRequirement.contract.filename &&
													(discountRequirement.contract.filename.split(
														'.'
													)[1] !==
														'word') |
														(discountRequirement.contract.filename.split(
															'.'
														)[1] !==
															'pdf')
											"
										/>
										<div
											v-else
											class="no_agreement_upload cp"
											@click="imgUploadClick('agreement_upload', 'agreement')"
										></div>
										<imgUpload
											v-show="!discountRequirement.contract.filename"
											ref="agreement_upload"
											:params="{
												ocr: false,
												loadding: false,
												isShowImg: true,
												isReUpload: false,
											}"
											@change="agreementUploadChange"
											:width="'42px'"
											:height="'48px'"
											:format="['pdf', 'jpg', 'jpeg', 'png']"
											class="no_agreement_upload dn"
										>
										</imgUpload>
									</div>
									<div class="mt10 dCC">
										<div class=" f12 ">
											<p class="tc">
												{{
													discountRequirement.contract.filename
														? discountRequirement.contract.filename.length > 7
															? discountRequirement.contract.filename.slice(
																	0,
																	2
															  ) +
															  "..." +
															  discountRequirement.contract.filename
																	.split(".")[0]
																	.slice(-3) +
															  "." +
															  discountRequirement.contract.filename.split(
																	"."
															  )[1]
															: discountRequirement.contract.filename
														: ""
												}}
											</p>
										</div>
										<div>
											<Button
												class="agreement_upload_btn f12"
												size="small"
												@click="imgUploadClick('agreement_upload', 'agreement')"
											>
												{{
													discountRequirement.contract.filename
														? "重新上传"
														: "上传合同"
												}}
											</Button>
										</div>
										<div class=" f12 ">
											<p v-if="!discountRequirement.contract.filename">
												jpg/png/pdf图片
											</p>
										</div>
									</div>
								</div>
							</div>
							<div class="fStart aic ml20">
								<p class="mr20">发票</p>
								<div class="maxw550">
									<div class="fStart invoice_bg">
										<div
											v-for="(item, index) in discountRequirement.invoice"
											:key="index"
											class=" df aic "
										>
											<div class="dCC invoice-item">
												<div class="invoice_upload">
													<div
														class="agreement_upload "
														v-if="item.filename"
													></div>
													<img
														:src="item.fileUrl"
														alt=""
														v-else-if="item.fileUrl"
													/>
													<div
														v-else
														class="imgUploadBg"
														@click="
															imgUploadClick(`imgUpload${index}`, 'img', index)
														"
													></div>
													<imgUpload
														:params="{
															ocr: false,
															loadding: false,
															isShowImg: true,
															isReUpload: false,
														}"
														:ref="`imgUpload${index}`"
														@change="imgUploadChange"
														:width="'42px'"
														:height="'48px'"
														v-show="!item.fileUrl"
														:format="['pdf', 'jpg', 'jpeg', 'png']"
														class="imgUploadBg dn"
													/>
												</div>

												<div class=" f12 ">
													<p class="c000">
														{{ item.fileUrl ? "发票" : "发票图片" }}
														{{ index + 1 }}
													</p>
												</div>
												<div class="fStart aic  ">
													<Button
														size="small"
														class="agreement_upload_btn"
														@click="
															imgUploadClick(`imgUpload${index}`, 'img', index)
														"
													>
														{{ item.fileUrl ? "重新上传" : "上传" }}
													</Button>
													<Button
														size="small"
														@click="invoiceDel(index)"
														class="delete_invoice ml10"
														><span class="delete_btn"></span
													></Button>
												</div>
												<div class=" f12 ">
													<p v-if="!item.fileUrl" class="c666">
														jpg/png/pdf图片
													</p>
												</div>
											</div>
										</div>

										<div class="dCC  w130 h130 invoiceAdd_bg">
											<div class="tc">
												<div class="invoiceAdd_inner cp" @click="invoiceAdd">
													<div class="invoiceAdd"></div>
												</div>
												<div class=" f12 mt10">
													<p>追加发票</p>
												</div>
												<Button
													class="invoice_btn "
													size="small"
													@click="invoiceAdd"
												>
													+ 追加
												</Button>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
						<div>
							<div>
								<Button class="mr10" @click="code = 2">重选贴入行</Button>
								<Button @click="reUpload">取消贴现</Button>
							</div>
							<Button
								type="primary"
								:disabled="!isFiled"
								class="w200 mt5"
								@click="nextBtnEvent"
								>开始贴现</Button
							>
						</div>
					</div>
				</div>
			</div>

			<!-- 贴现操作指南 -->
			<div v-if="code == 4" class="bs2 mb20 bgfff tl">
				<div
					class="pt10 plr20 pb40"
					v-if="allParam.discountData.bankCode === 'HUARUN'"
				>
					<div class="df aic fStart mb16  pl7 ">
						<div class="mr10 ptb5 f20 fb c333 mr20">
							<div>票据所在网银</div>
						</div>
						<div
							class="h24  oh  t1"
							v-for="(item, index) in code4Param.bankList"
							v-if="index < 5"
							@click="chooseTab(item.bankCode, index)"
						>
							<div
								class="df aic jcc h24 plr20 mr10 cp c333"
								:class="[
									code4Param.activeBankCode === item.bankCode
										? 'bs3 bbinitial bank_new_tab_active'
										: 'bw2 bbin cp bank_new_tab',
								]"
							>
								<!-- <i class="dl wh20 mr10" :style="operateBankLogoStyle(item.bankCode)"></i> -->
								<span class="f14 ">{{ item.bankName }}</span>
							</div>
						</div>

						<div
							class="df aic jcc pr w170 h24"
							v-if="code4Param.bankList.length > 5"
						>
							<span
								class="fb cp  h24  tc l24 c333 f12 plr8 br4 bCBCBCB"
								@click.stop="
									code4Param.moreShowStatus = !code4Param.moreShowStatus
								"
								>更多</span
							>
							<div
								class="pa r0 bgfff w170 t40 bs2 br4 zi2 h300 more_div"
								v-if="code4Param.moreShowStatus"
							>
								<div class="pa r0 bgfff w170 bs2 br4 zi2 h300 oya scroll-style">
									<div
										class="df aic jcc l40 cp dp-text-bg-primary-hover"
										v-for="(item, index) in code4Param.bankList"
										v-if="index > 4"
										@click="chooseTab(item.bankCode, index)"
									>
										<i
											class="wh20 mr8"
											:style="operateBankLogoStyle(item.bankCode)"
										></i>
										<span>{{ item.bankName }}</span>
									</div>
								</div>
							</div>
						</div>
					</div>

					<!--网银操作-->
					<div class="df h421 mb40 bgFAFAFA br10 p10 fSpace ">
						<div class=" w707 br10 h394 mr10 oh">
							<img
								v-if="code4Param.activeBankOpration[stepImge].imgUrl"
								:src="
									bank_discount_img(
										code4Param.activeBankOpration[stepImge].imgUrl
									)
								"
								alt=""
								class="w100b"
							/>
							<div v-else class="w100b h100b dCC bgeee">
								<span class="dl  image_fill"></span>
							</div>
						</div>
						<div class="f1 oh oya  h100b">
							<template v-for="(item, index) in code4Param.activeBankOpration">
								<template v-if="!item.imgUrl">
									<div
										class="fSpace  mb10 cp"
										@click="
											stepImge =
												code4Param.activeBankOpration[0].stepStatus == 'other'
													? index
													: index
										"
									>
										<div class="w188 h103 pr">
											<span
												v-if="
													code4Param.activeBankOpration[0].stepStatus ===
														'other' && index === 0
												"
											></span>
											<span v-else class="w16 h16 cfff bg666 pa t0 l0 tc l16">{{
												code4Param.activeBankOpration[0].stepStatus == "other"
													? index
													: index + 1
											}}</span>
											<!-- <p v-if="item.stepDes!==null">{{item.stepDes || '第'+(code4Param.activeBankOpration[0].stepStatus=='other'?index:index+1)+'步'}}</p> -->
											<!-- <p v-html="item.content"></p> -->
											<!-- {{item}} -->
											<div class="w100b h100b dCC bgeee">
												<span class="dl  image_fill_small"></span>
											</div>
										</div>
										<div class="w197  f12 c333">
											<p v-if="item.stepDes !== null">
												{{
													item.stepDes ||
														"第" +
															(code4Param.activeBankOpration[0].stepStatus ==
															"other"
																? index
																: index + 1) +
															"步："
												}}
												<span v-html="item.content"></span>
											</p>
											<!-- <p v-html="item.content"></p> -->
										</div>
									</div>
								</template>
								<template v-else>
									<div
										class="fSpace  mb10 cp"
										@click="
											stepImge =
												code4Param.activeBankOpration[0].stepStatus == 'other'
													? index
													: index
										"
									>
										<div class="w188 h103 oh cp pr">
											<span class="w16 h16 cfff bg666 pa t0 l0 tc l16">{{
												code4Param.activeBankOpration[0].stepStatus == "other"
													? index
													: index + 1
											}}</span>
											<img
												v-if="item.imgUrl"
												:src="bank_discount_img(item.imgUrl)"
												alt=""
												class="w100b "
											/>
										</div>
										<div class="w197  f12 c333">
											<p v-if="item.stepDes !== null">
												{{
													item.stepDes ||
														"第" +
															(code4Param.activeBankOpration[0].stepStatus ==
															"other"
																? index
																: index + 1) +
															"步："
												}}
												<span v-html="item.content"></span>
											</p>
											<!-- <p v-if="item.imgUrl" v-html="item.content"></p> -->
										</div>
									</div>
								</template>
							</template>
						</div>
					</div>
					<!--票面信息复制-->
					<div class="c999 mb20">请根据以下信息填写</div>
					<div>
						<div class="w100b bccc  mb20">
							<div class="tc ft14 c333 bbccc ptb4">
								网银操作可能需要填写以下要素
							</div>
							<div class="fStart">
								<div class="brccc">
									<p class="bbccc w400 ">
										<span class="dl w80 bgF1F5F8 pl10  c666  ptb4">票号</span
										><span class="w250 dl ptb4 pl20 c333">{{
											allParam.discountData.billNo
										}}</span
										><span
											class="btnCopy ptb2 plr2 bCBCBCB ml20 br4 other-color-btn cp c333 fn hoverunder"
											ghost
											:data-clipboard-text="allParam.discountData.billNo"
											>复制</span
										>
									</p>
									<p class="bbccc w400">
										<span class="dl w80 bgF1F5F8 pl10  c666 ptb4">贴入行</span
										><span class="w250 dl ptb4  pl20 c333">{{
											allParam.discountData.bankName
										}}</span
										><span
											class="btnCopy ptb2 plr2 bCBCBCB ml20 br4 other-color-btn cp c333 hoverunder fn mr3"
											ghost
											:data-clipboard-text="
												allParam.discountData.discountBankName ||
													allParam.discountData.bankName
											"
											>复制</span
										>
									</p>
									<p class="bbccc w400">
										<span class="dl w80 bgF1F5F8 pl10 c666 ptb4 ">贴入行号</span
										><span class="w250 dl ptb4 pl20 c333">{{
											allParam.discountData.discountBankNum
										}}</span
										><span
											class="btnCopy ptb2 plr2 bCBCBCB ml20 br4 other-color-btn cp c333 hoverunder fn mr3"
											ghost
											:data-clipboard-text="
												allParam.discountData.discountBankNum
											"
											>复制</span
										>
									</p>
									<p class=" w400">
										<span class="dl w80 bgF1F5F8 pl10  c666 ptb4">收款账号</span
										><span class="w250 dl ptb4 pl20 c333">持票账户账号</span>
									</p>
								</div>
								<div class="brccc">
									<p class="bbccc w400">
										<span class="dl w80 bgF1F5F8 pl10  c666  ptb4"
											>贴现种类</span
										><span class="w250 dl ptb4 pl20 c333">行外贴现</span>
									</p>
									<p class="bbccc w400">
										<span class="dl w80 bgF1F5F8 pl10  c666 ptb4">付息方式</span
										><span class="w250 dl ptb4  pl20 c333">卖方付息</span>
									</p>
									<p class="bbccc w400">
										<span class="dl w80 bgF1F5F8 pl10 c666 ptb4 ">清算方式</span
										><span class="w250 dl ptb4 pl20 c333">线上清算</span>
									</p>
									<p class=" w400">
										<span class="dl w80 bgF1F5F8 pl10  c666 ptb4">贴现利率</span
										><span class="w250 dl ptb4 pl20 c333">{{
											Number(
												allParam.discountData.realDiscountRate ||
													allParam.discountData.activDiscountRate
											).mul(100)
										}}</span>
									</p>
								</div>

								<div class="brccc f12 f1 pl20 pt10 c333">
									<p class="c666">特别操作提示：</p>
									<p>无</p>
								</div>
							</div>
						</div>
					</div>
					<div
						v-if="allParam.discountData.bankCode === 'PINGAN'"
						class="mb40 brccc blccc bbccc pl20 ptb4"
					>
						贴入账号：0
						（如贴出票据所在网银为【浦东发展银行】/【中国建设银行】，请填写：<span
							class="c0077DA"
							>99262009900010</span
						>
						<span
							class="btnCopy other-color-btn cp c0077DA fn hoverunder"
							ghost
							:data-clipboard-text="'99262009900010'"
							>复制</span
						>
						）
					</div>
					<div class="df aic jcc">
						<Button type="primary" class="mr15" @click="nextBtnEvent"
							>已收到贴现款，获取贴现凭证</Button
						>
						<Button @click="reUpload()">取消贴现</Button>
					</div>
				</div>
				<div class="pt20 plr40 pb40" v-else>
					<div class="mb20">
						<span
							class="dl l25 dp-c-primary dp-bc-primary bbinitial bw2 mr8 f18 fb"
							>操作指南</span
						>
						<span class="c666"
							>（请务必使用“{{
								allParam.discountAcctDto.corpName
							}}”名下账号进行贴现，否则将贴现失败）</span
						>
					</div>
					<div class="df aic jcb mb16 bgFBFBFB pl7 bccc">
						<div class="mr10 ptb5">
							<div>网银操作方式：</div>
							<div class="c999">根据您的网银进行选择</div>
						</div>
						<div
							class="h46 w162 oh pr t1"
							v-for="(item, index) in code4Param.bankList"
							v-if="index < 5"
							@click="chooseTab(item.bankCode, index)"
						>
							<div
								class="df aic jcc h40 w162 "
								:class="[
									code4Param.activeBankCode == item.bankCode
										? 'bs3 bbinitial bank_tab_active'
										: 'bw2 bbin cp bank_tab',
								]"
							>
								<i
									class="dl wh20 mr10"
									:style="operateBankLogoStyle(item.bankCode)"
								></i>
								<span class="fb  fb">{{ item.bankName }}</span>
							</div>
						</div>
						<div
							class="df aic jcc pr h40"
							v-if="code4Param.bankList.length > 5"
						>
							<span
								class="fb cp pl38 pr38 h40 w78 l40 dp-c-primary pr t8"
								@click.stop="
									code4Param.moreShowStatus = !code4Param.moreShowStatus
								"
								>更多</span
							>
							<div
								class="pa r0 bgfff w170 t44 bs2 br4 zi2 h300 more_div"
								v-if="code4Param.moreShowStatus"
							>
								<div class="pa r0 bgfff w170 bs2 br4 zi2 h300 oya scroll-style">
									<div
										class="df aic jcc l40 cp dp-text-bg-primary-hover"
										v-for="(item, index) in code4Param.bankList"
										v-if="index > 4"
										@click="chooseTab(item.bankCode, index)"
									>
										<i
											class="wh20 mr8"
											:style="operateBankLogoStyle(item.bankCode)"
										></i>
										<span>{{ item.bankName }}</span>
									</div>
								</div>
							</div>
						</div>
					</div>

					<!--网银操作-->
					<div class="df h280 mb40 bccc">
						<div class="fn w60 df aic fDR">
							<Button
								class="fr ml10"
								icon="ios-arrow-back"
								type="primary"
								shape="circle"
								@click="moveImg('L')"
							></Button>
						</div>
						<div class="f1 oh">
							<div
								class="w100b h100b wsn pr animate"
								:style="{ left: '-' + code4Param.left + 'px' }"
							>
								<div
									class="pr h100b dp-bg-img w366 dl mr15"
									v-for="(item, index) in code4Param.activeBankOpration"
								>
									<template v-if="!item.imgUrl">
										<div class="pa left0 t0 df">
											<span
												class="dl pl15 pr15 cfff bg333 hl25 mr8 f00a"
												v-if="item.stepDes !== null"
												>{{
													item.stepDes ||
														"第" +
															(code4Param.activeBankOpration[0].stepStatus ==
															"other"
																? index
																: index + 1) +
															"步"
												}}</span
											>
											<span
												class="l25 f1 ws cfff"
												v-if="item.imgUrl"
												v-html="item.content"
											></span>
										</div>
										<div
											class="ws f14 cfff l28 pa w100b h100b df aic jcc"
											:class="item.stepDes !== null ? 'pt25' : ''"
										>
											<p class="pl20 pr20 maxh100b" v-html="item.content"></p>
										</div>
									</template>
									<div class="ws f14 cfff l28 pa w100b h100b df fDC" v-else>
										<div class="df f00a">
											<span
												class="dl pl15 pr15 cfff bg333 hl25 mr8 f00a"
												v-if="item.stepDes !== null"
												>{{
													item.stepDes ||
														"第" +
															(code4Param.activeBankOpration[0].stepStatus ==
															"other"
																? index
																: index + 1) +
															"步"
												}}</span
											>
											<span
												class="l25 f1 ws cfff"
												v-if="item.imgUrl"
												v-html="item.content"
											></span>
										</div>
										<div
											class="f1 dp-bi-img ml10 mt10 mr10"
											:style="
												'background-image:url(' +
													bank_discount_img(item.imgUrl) +
													')'
											"
										></div>
									</div>
									<Button
										class="pa r10 b10"
										icon="ios-search"
										type="primary"
										@click="showImg(item, index)"
									></Button>
								</div>

								<template v-if="code4Param.activeBankOpration.length == 1">
									<div class="pr h100b dp-bg-img w366 dl mr15"></div>
									<div class="pr h100b dp-bg-img w366 dl mr15">
										<p class="pa w100b h100b ws df aic jcc f14 cfff plr75">
											网银操作完成后，<br />可返回快贴宝官网打印贴现凭证。
										</p>
									</div>
								</template>

								<template v-if="code4Param.activeBankOpration.length == 2">
									<div class="pr h100b dp-bg-img w366 dl mr15">
										<p class="pa w100b h100b ws df aic jcc f14 cfff plr75">
											网银操作完成后，<br />可返回快贴宝官网打印贴现凭证。
										</p>
									</div>
								</template>
							</div>
						</div>
						<div class="fn w60 df aic fDRR">
							<Button
								class="fr mr10"
								icon="ios-arrow-forward"
								type="primary"
								shape="circle"
								@click="moveImg('R')"
							></Button>
						</div>
					</div>
					<!--票面信息复制-->
					<div class="c999 mb20">请根据以下信息填写</div>
					<div class="df ais jcc bbccc ">
						<div class="fn df fDC">
							<div
								class="hl50 blinitial btinitial bbinitial dp-bc-table-active c666 fn tl dp-bg-table-active pl10"
							>
								票号
							</div>
							<div class="df aic f1 blccc pl10 pr38">
								<span class="mr10 fn">{{ allParam.discountData.billNo }}</span>
								<span
									class="btnCopy other-color-btn cp c0077DA fn hoverunder"
									ghost
									:data-clipboard-text="allParam.discountData.billNo"
									>复制</span
								>
							</div>
						</div>
						<div class="f1 df fDC">
							<div
								class="hl50 btinitial bbinitial dp-bc-table-active c666 fn tl dp-bg-table-active"
							>
								贴入行全称
							</div>
							<div class="df aic f1">
								<span class="mr10">{{
									allParam.discountData.discountBankName ||
										allParam.discountData.bankName
								}}</span>
								<span
									class="btnCopy other-color-btn cp c0077DA hoverunder fn mr3"
									ghost
									:data-clipboard-text="
										allParam.discountData.discountBankName ||
											allParam.discountData.bankName
									"
									>复制</span
								>
							</div>
						</div>
						<div class="f1 df fDC">
							<div
								class="hl50 btinitial bbinitial dp-bc-table-active c666 fn tl dp-bg-table-active"
							>
								贴入行号
							</div>
							<div class="df aic f1">
								<span class="mr10 wbba">{{
									allParam.discountData.discountBankNum
								}}</span>
								<span
									class="btnCopy other-color-btn cp c0077DA hoverunder fn mr3"
									ghost
									:data-clipboard-text="allParam.discountData.discountBankNum"
									>复制</span
								>
							</div>
						</div>
						<div class="f1 df fDC">
							<div
								class="hl50 btinitial bbinitial dp-bc-table-active c666 fn tl dp-bg-table-active"
							>
								贴现利率
							</div>
							<div class="df aic f1">
								<span class="mb5 mr10"
									>{{
										Number(
											allParam.discountData.realDiscountRate ||
												allParam.discountData.activDiscountRate
										).mul(100)
									}}%</span
								>
							</div>
						</div>
						<div class="f1 df fDC">
							<div
								class="hl50 brinitial btinitial bbinitial dp-bc-table-active c666 fn tl dp-bg-table-active"
							>
								线上清算
							</div>
							<div class="df aic hl50 f1 brccc">
								<span>否</span>
							</div>
						</div>
					</div>
					<div
						v-if="allParam.discountData.bankCode === 'PINGAN'"
						class="mb40 brccc blccc bbccc pl20 ptb4"
					>
						贴入账号：0
						（如贴出票据所在网银为【浦东发展银行】/【中国建设银行】，请填写：<span
							class="c0077DA"
							>99262009900010</span
						>
						<span
							class="btnCopy other-color-btn cp c0077DA fn hoverunder"
							ghost
							:data-clipboard-text="'99262009900010'"
							>复制</span
						>
						）
					</div>
					<div class="df aic jcc mt20">
						<Button
							v-if="isShowWhlhDtoBtn"
							type="primary"
							class="mr15"
							@click="whlhDtoExamined"
							>合同审核</Button
						>
						<Button type="primary" class="mr15" @click="nextBtnEvent"
							>我已经操作成功，获取贴现凭证</Button
						>
						<Button @click="reUpload()">取消贴现</Button>
					</div>
				</div>
			</div>

			<div v-if="code == 5" class="bs2 mb60 bgfff">
				<div class="df fDC aic jcc h670">
					<Icon type="ios-time" class="dp-c-waite f90 mb30" />
					<div class="f24 fb mb23">正在校验贴现结<br />请耐心等待...</div>
					<div class="dp-c-primary mb15">请勿刷新/关闭当前页面</div>
					<div class="df fDC jcc ptb10 w440 h100 bD73737 bgFFF2F2">
						<div class="c666 f16 mb10">小提示</div>
						<div class="c666 f16">
							贴现款预计在校验成功后1分钟内到账<br />校验成功，即刻获取贴现凭证
						</div>
					</div>
				</div>
			</div>

			<!-- 重新校验 -->
			<div v-if="code == 7" class="bs2 mb60 bgfff">
				<div class="df fDC aic jcc h670">
					<div class="tip_prompt wh80 mb25"></div>
					<div class="fb f24 mb25">贴现未成功</div>

					<div
						class="dp-c-fail f16 mb25"
						v-if="allParam.discountData.status == '30'"
					>
						失败原因：{{
							allParam.discountData.discountSyncOrderDto &&
								allParam.discountData.discountSyncOrderDto.failReason
						}}
					</div>
					<div class="f16 mb25" v-else>
						当前状态：{{
							allParam.discountData.discountSyncOrderJdDto
								? allParam.discountData.discountSyncOrderJdDto.orderStatusDesc
								: allParam.discountData.statusDesc
						}}
					</div>

					<div class="mb20 df aic">
						<template v-if="allParam.discountData.status == '30'">
							<Button class="mr15" @click="reUpload()">返回</Button>
						</template>

						<template v-else>
							<Button type="primary" class="mr15" @click="checkOrderInfo()"
								>重新校验</Button
							>
							<Button type="info" class="mr15" @click="preBtnEvent()"
								>继续查看操作指南</Button
							>
							<Button class="mr15" @click="reUpload()">取消本次贴现</Button>
						</template>
					</div>

					<div class="df fDC jcc ptb10 w440 h100 bD73737 bgFFF2F2">
						<div class="c666 f16 mb15">小提示</div>
						<div class="c666 f16">
							您可以尝试重新校验贴现结果<br />如操作遇到问题，请联系<span
								class="c0077DA cp"
								@click="handleCustomerBtn()"
								>平台协助</span
							>
						</div>
					</div>
				</div>
			</div>

			<!-- 贴现成功 -->
			<div v-if="code == 6" class="bs2 mb60 bgfff">
				<div
					v-if="
						this.allParam.discountData.bankCode === 'HUARUN' || isHUARUNFinsh
					"
					class="df fDC aic jcc h670"
				>
					<div class="df aic">
						<span class="huarun_success dl mr10"></span>
						<span class="c333 f18 fm">贴现订单已完成</span>
					</div>
					<!-- <i class="wechat_QR_code_a dl mb30 mt30"></i> -->
					<div class="w200 h200 mb30 mt20">
						<img
							:src="showHuarunBankSign.HuarunQrCode"
							alt=""
							class="w100b  "
						/>
					</div>
					<div class=" f14 mb20 df aic c333">
						<span class="wechat_fill dl mr10"></span>
						微信扫描华润银行“润秒贴”小程序获取贴现凭证
					</div>
					<div class="df aic">
						<Button class="mr15" @click="tolink">进入账户中心，查看订单</Button>
						<Button type="primary" @click="reUpload()">完成</Button>
					</div>
				</div>
				<div v-else class="df fDC aic jcc h670">
					<Icon class="f90 dp-c-success mb30" type="md-checkmark-circle" />
					<div class="fb f19 mb20">恭喜您，贴现成功</div>
					<div class="tl mb10">
						<span class="f16"
							>回款金额：{{
								formatMoney(
									allParam.discountData.realDiscountAmount ||
										allParam.discountData.activDiscountAmount
								)
							}}</span
						>
						<span class="c666 f16">（请在网银内查收，预计1分钟内到账）</span>
					</div>
					<!--<div class="mb25">
            <span class="f16">本次贴现支付服务费用：{{formatMoney(allParam.discountData.serviceCharge)}}</span>
            <span class="c666 f16">（平台收取）</span>
          </div>-->
					<div class="df aic">
						<Button type="primary" class="mr15" @click="getDiscount()"
							>获取贴现凭证</Button
						>
						<Button @click="reUpload()">返回</Button>
					</div>

					<!-- <div class="electronicBg">
            <div class="electronicBg-left">
              <div class="logo">
                <img height="20" src="/static/img/img_bank_big/logo_hnsxb@2x.png" alt="">
                <span>×</span>
                <img height="20" src="/static/img/img_bank_big/logo_ktb@2x.png" alt="">
              </div>

              <p class="tip c666 f14">随存随取电子存款已上线，让您的收益最大化</p>
              <p class="rate c000 f14" v-if="depositRate[0]">隔夜利率：<span class="f18 ce1241a"><em class="f26 ftn">{{depositRate[0].rate.mul(100).toFixed(2)}} </em>%</span></p>
            </div>
            <div class="electronicBg-right">
              <Button class="w120" type="primary" @click="electronicEvent">立即存入</Button>
            </div>
          </div> -->
				</div>
			</div>

			<!-- 蓝海贴现操作指引 -->
			<div v-if="code == 8" class="bs2 mb20 bgfff tl pr">
				<div class="dCC h400 mb40">
					<p class="f20 fb">请输入上一手贸易信息进行额度查询</p>
					<span class="f16">（上一手背书/合同买方）</span>
					<input
						style="width: 400px; border-radius:20px;border:1px solid #ccc;text-align:center;height: 36px;"
						class="mt20 "
						v-model="frontCertName"
						placeholder="请输入上一手贸易公司名称"
					/>
					<Button
						type="primary"
						class="w200 mt15"
						style="border-radius:20px;"
						@click="queryAmountLimit"
						>查询额度</Button
					>
				</div>

				<div class="df aic m0a h100 jcc">
					<Button
						type="primary"
						style="border-radius:20px;"
						v-if="
							allParam.discountData.discountChannel === 'WHLH' ||
								allParam.discountData.discountChannel === 'fumin'
						"
						class="mr10"
						@click="nextBtnEvent"
						>跳过查询，上传新贸易资料</Button
					>
					<Button style="border-radius:20px;" @click="reUpload"
						>取消贴现</Button
					>
				</div>
			</div>
			<!-- 额度查询结果 -->
			<div v-if="code == 9" class="bs2 mb20 bgfff tl">
				<div class="dCC  h300">
					<p class="f20 fb ">请核对额度信息</p>
					<div
						class="df jcb mt20"
						v-if="allParam.discountData.discountChannel === 'WHLH'"
					>
						<div class="fCStart p20 w400">
							<span>本公司在行贴现额度</span>
							<Divider></Divider>
							<span
								>剩余额度：{{
									formatMoney(examineDtoAmount.amountLimit, 2, "")
								}}</span
							>
							<span class="mt20"
								>本次贴现需扣用额度：{{
									formatMoney(examineDtoAmount.billAmount, 2, "")
								}}</span
							>
							<div
								v-if="
									examineDtoAmount.amountLimit > examineDtoAmount.billAmount
								"
								class="mt20"
							>
								<Icon type="ios-checkmark-circle" size="22" /> 额度满足贴现需求
							</div>
							<div v-else class="mt20">
								<Icon class="" type="ios-close-circle" size="22" />
								额度不足，请补充贸易背景资料
							</div>
						</div>
						<Divider type="vertical" class="h100b"></Divider>
						<div class="fCStart p20 w400">
							<span>贸易资料贴现额度</span>
							<Divider></Divider>
							<span
								>剩余额度：{{
									formatMoney(
										Number(examineDtoAmount.contractAmountLimit).add(
											examineDtoAmount.invoiceAmountLimit
										),
										2,
										""
									)
								}}</span
							>
							<span class="mt20"
								>本次贴现需扣用额度：{{
									formatMoney(examineDtoAmount.billAmount, 2, "")
								}}</span
							>
							<div
								v-if="
									Number(examineDtoAmount.contractAmountLimit).add(
										examineDtoAmount.invoiceAmountLimit
									) > examineDtoAmount.billAmount
								"
								class="mt20"
							>
								<Icon type="ios-checkmark-circle" class="f22  " size="22" />
								额度满足贴现需求
							</div>
							<div v-else class="mt20">
								<Icon class="" type="ios-close-circle" size="22" />
								额度不足，请补充贸易背景资料
							</div>
						</div>
					</div>
					<div
						class="df jcb mt20"
						v-else-if="allParam.discountData.discountChannel === 'fumin'"
					>
						<div class="fCStart p20 w400">
							<p class="tc">贸易资料贴现额度</p>
							<Divider></Divider>
							<span
								>剩余额度：{{
									formatMoney(Number(examineDtoAmount.amountLimit), 2, "")
								}}</span
							>
							<span class="mt20"
								>本次贴现需扣用额度：{{
									formatMoney(examineDtoAmount.billAmount, 2, "")
								}}</span
							>
							<div
								v-if="
									Number(examineDtoAmount.amountLimit) >
										examineDtoAmount.billAmount
								"
								class="mt20"
							>
								<Icon type="ios-checkmark-circle" class="f22  " size="22" />
								额度满足贴现需求
							</div>
							<div v-else class="mt20">
								<Icon class="" type="ios-close-circle" size="22" />
								额度不足，请补充贸易背景资料
							</div>
						</div>
					</div>
				</div>
				<div class="df aic m0a h100 jcc">
					<!-- 蓝海满足额度充足 -->
					<Button style="border-radius:20px;" class="mr10" @click="queryAgain"
						>重新查询额度</Button
					>
					<Button
						type="primary"
						style="border-radius:20px;"
						v-if="
							allParam.discountData.discountChannel === 'WHLH' &&
								examineDtoAmount.amountLimit > examineDtoAmount.billAmount &&
								Number(examineDtoAmount.contractAmountLimit).add(
									examineDtoAmount.invoiceAmountLimit
								) > examineDtoAmount.billAmount
						"
						class="mr10"
						@click="nextBtnEvent"
						>确认，前往网银贴现</Button
					>
					<!-- 富民满足额度充足 -->
					<Button
						type="primary"
						style="border-radius:20px;"
						v-else-if="
							allParam.discountData.discountChannel === 'fumin' &&
								Number(examineDtoAmount.amountLimit) >
									examineDtoAmount.billAmount
						"
						class="mr10"
						@click="nextBtnEvent"
						>确认，前往网银贴现</Button
					>
					<Button
						type="primary"
						style="border-radius:20px;"
						v-else
						class="mr10"
						@click="nextBtnEvent"
						>上传新贸易资料</Button
					>
					<Button style="border-radius:20px;" @click="reUpload"
						>取消贴现</Button
					>
				</div>
			</div>
			<!-- 蓝海补充贸易背景资料 -->
			<div v-if="code == 10" class="bs2 mb20 bgfff tl">
				<div class="dCC  ">
					<p class="f20 fb mt30">请上传贸易资料</p>
					<span class="f16">合同或发票至少上传一项</span>
					<div class=" mt20 w70b">
						<div>
							<p>合同</p>
							<Divider class="w100b mt10"></Divider>
							<div class="df aic ">
								<div class="dCC w130 h130 bccc agreement_bg">
									<div class="agreement">
										<div
											class="agreement_upload "
											v-if="
												discountRequirement.contract.filename &&
													discountRequirement.contract.filename.split(
														'.'
													)[1] === 'pdf'
											"
										></div>
										<img
											:src="discountRequirement.contract.fileUrl"
											alt=""
											v-else-if="
												discountRequirement.contract.filename &&
													(discountRequirement.contract.filename.split(
														'.'
													)[1] !==
														'word') |
														(discountRequirement.contract.filename.split(
															'.'
														)[1] !==
															'pdf')
											"
										/>
										<div
											v-else
											class="no_agreement_upload cp"
											@click="imgUploadClick('agreement_upload', 'agreement')"
										></div>
										<imgUpload
											v-show="!discountRequirement.contract.filename"
											ref="agreement_upload"
											:params="{
												ocr: false,
												loadding: false,
												isShowImg: true,
												isReUpload: false,
											}"
											@change="agreementUploadChange"
											:width="'42px'"
											:height="'48px'"
											:format="['pdf', 'jpg', 'jpeg', 'png']"
											class="no_agreement_upload dn"
										>
										</imgUpload>
									</div>
									<div class="mt10 dCC">
										<div class=" f12 ">
											<p class="tc">
												{{
													discountRequirement.contract.filename
														? discountRequirement.contract.filename.length > 7
															? discountRequirement.contract.filename.slice(
																	0,
																	2
															  ) +
															  "..." +
															  discountRequirement.contract.filename
																	.split(".")[0]
																	.slice(-3) +
															  "." +
															  discountRequirement.contract.filename.split(
																	"."
															  )[1]
															: discountRequirement.contract.filename
														: ""
												}}
											</p>
										</div>
										<div>
											<Button
												class="agreement_upload_btn f12"
												size="small"
												@click="imgUploadClick('agreement_upload', 'agreement')"
											>
												{{
													discountRequirement.contract.filename
														? "重新上传"
														: "上传合同"
												}}
											</Button>
										</div>
										<div class=" f12 ">
											<p v-if="!discountRequirement.contract.filename">
												jpg/png/pdf图片
											</p>
										</div>
									</div>
								</div>
							</div>
						</div>
						<div class="mt20">
							<p>发票</p>
							<Divider class="w100b mt10 mb10"></Divider>
							<div class=" ">
								<div class="df aic">
									<span>发票数量</span>
									<RadioGroup
										v-model="invoiceType"
										type="button"
										button-style="solid"
										size="small"
										class="ml10 "
									>
										<Radio label="01">10张以下</Radio>
										<Radio label="02">十张（含）以上</Radio>
									</RadioGroup>
								</div>
								<div class="df mt10" v-if="invoiceType === '01'">
									<div class="fStart invoice_bg  " style="width: auto;">
										<div
											v-for="(item, index) in discountRequirement.invoice"
											:key="index"
											class=" df aic "
										>
											<div class="dCC invoice-item">
												<div class="invoice_upload">
													<div
														class="agreement_upload "
														v-if="item.filename"
													></div>
													<img
														:src="item.fileUrl"
														alt=""
														v-else-if="item.fileUrl"
													/>
													<div
														v-else
														class="imgUploadBg"
														@click="
															imgUploadClick(`imgUpload${index}`, 'img', index)
														"
													></div>
													<imgUpload
														:params="{
															ocr: false,
															loadding: false,
															isShowImg: true,
															isReUpload: false,
														}"
														:ref="`imgUpload${index}`"
														@change="imgUploadChange"
														:width="'42px'"
														:height="'48px'"
														v-show="!item.fileUrl"
														:format="['pdf', 'jpg', 'jpeg', 'png']"
														class="imgUploadBg dn"
													/>
												</div>

												<div class=" f12 ">
													<p class="c000">
														{{ item.fileUrl ? "发票" : "发票图片" }}
													</p>
												</div>
												<div class="fStart aic  ">
													<Button
														size="small"
														class="agreement_upload_btn"
														@click="
															imgUploadClick(`imgUpload${index}`, 'img', index)
														"
													>
														{{ item.fileUrl ? "重新上传" : "上传" }}
													</Button>
												</div>
												<div class=" f12 ">
													<p v-if="!item.fileUrl" class="c666">
														jpg/png/pdf图片
													</p>
												</div>
											</div>
										</div>
									</div>
									<div class="">
										<p>一张支持图片</p>
										<p>多张（< 10张）请合并至1个pdf</p>
									</div>
								</div>
								<div class="df mt10" v-else>
									<div class="dCC w130 h130 bccc agreement_bg ">
										<div class="agreement">
											<div
												class="agreement_upload_excel "
												v-if="discountRequirement.invoiceTemplateFile.filename"
											></div>

											<div
												v-else
												class="no_agreement_upload cp"
												@click="imgUploadClick('agreement_upload', 'agreement')"
											></div>
											<imgUpload
												v-show="
													!discountRequirement.invoiceTemplateFile.filename
												"
												ref="invoice_upload"
												:params="{
													ocr: false,
													loadding: false,
													isShowImg: true,
													isReUpload: false,
												}"
												@change="invoiceUploadChange"
												:width="'42px'"
												:height="'48px'"
												:format="['xls', 'xlsx']"
												class="no_agreement_upload dn"
											>
											</imgUpload>
										</div>
										<div class="mt10 dCC">
											<div class=" f12 ">
												<p class="tc">
													{{
														discountRequirement.invoiceTemplateFile.filename
															? discountRequirement.invoiceTemplateFile.filename
																	.length > 7
																? discountRequirement.invoiceTemplateFile.filename.slice(
																		0,
																		2
																  ) +
																  "..." +
																  discountRequirement.invoiceTemplateFile.filename
																		.split(".")[0]
																		.slice(-3) +
																  "." +
																  discountRequirement.invoiceTemplateFile.filename.split(
																		"."
																  )[1]
																: discountRequirement.invoiceTemplateFile
																		.filename
															: ""
													}}
												</p>
											</div>
											<div>
												<Button
													class="agreement_upload_btn f12"
													size="small"
													@click="imgUploadClick('invoice_upload', 'other')"
												>
													{{
														discountRequirement.invoiceTemplateFile.filename
															? "重新上传"
															: "上传发票"
													}}
												</Button>
											</div>
											<div class=" f12 ">
												<p
													v-if="
														!discountRequirement.invoiceTemplateFile.filename
													"
												>
													xls/xlsx
												</p>
											</div>
										</div>
									</div>
									<div class="ml20">
										<p>步骤：</p>
										<p>
											1、下载清单模板
											<a
												href="https://oss.rzline.com/common/template/whlh/discount_whlh_invoice_template.xls"
												class="ml10 h30"
												download
												><Button size="small" class="ml10">下载</Button></a
											>
										</p>
										<p>2、按模板填写</p>
										<p>3、点击左侧按钮上传</p>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
				<div class="df aic m0a h100 jcc">
					<Button
						type="primary"
						style="border-radius:20px;"
						v-if="true"
						class="mr10 w200"
						@click="nextBtnEvent"
						>提交审核</Button
					>
					<Button style="border-radius:20px;" @click="reUpload"
						>取消贴现</Button
					>
				</div>
			</div>
			<!-- 富民补充贸易背景资料 -->
			<div v-if="code == 14" class="bs2 mb20 bgfff tl">
				<div class="dCC  ">
					<p class="f20 fb mt30">请上传贸易资料</p>
					<span class="f16">上一手背书的【合同】及【发票】</span>
					<div class=" mt20 w70b fRowCenter aifs ">
						<div>
							<p>合同</p>
							<Divider class="w100b mt10"></Divider>
							<div class="df  fDC jcfs">
								<div class="dCC w200 h200 bccc agreement_bg">
									<div class="agreement" style="width:200px">
										<div
											class="agreement_upload "
											v-if="
												discountRequirement.contract.filename &&
													discountRequirement.contract.filename.split(
														'.'
													)[1] === 'pdf'
											"
										></div>
										<img
											:src="discountRequirement.contract.fileUrl"
											alt=""
											v-else-if="
												discountRequirement.contract.filename &&
													(discountRequirement.contract.filename.split(
														'.'
													)[1] !==
														'word') |
														(discountRequirement.contract.filename.split(
															'.'
														)[1] !==
															'pdf')
											"
										/>
										<div
											v-else
											class="no_agreement_upload cp"
											@click="imgUploadClick('agreement_upload', 'agreement')"
										></div>
										<imgUpload
											v-show="!discountRequirement.contract.filename"
											ref="agreement_upload"
											:params="{
												ocr: false,
												loadding: false,
												isShowImg: true,
												isReUpload: false,
											}"
											@change="agreementUploadChange"
											:width="'42px'"
											:height="'48px'"
											:format="['pdf', 'jpg', 'jpeg', 'png']"
											class="no_agreement_upload dn"
										>
										</imgUpload>
									</div>
									<div class="mt10 dCC">
										<div class=" f12 ">
											<p class="tc">
												{{
													discountRequirement.contract.filename
														? discountRequirement.contract.filename.length > 7
															? discountRequirement.contract.filename.slice(
																	0,
																	2
															  ) +
															  "..." +
															  discountRequirement.contract.filename
																	.split(".")[0]
																	.slice(-3) +
															  "." +
															  discountRequirement.contract.filename.split(
																	"."
															  )[1]
															: discountRequirement.contract.filename
														: ""
												}}
											</p>
										</div>
										<div>
											<Button
												class="agreement_upload_btn f12"
												size="small"
												@click="imgUploadClick('agreement_upload', 'agreement')"
											>
												{{
													discountRequirement.contract.filename
														? "重新上传"
														: "上传合同"
												}}
											</Button>
										</div>
										<div class=" f12 ">
											<p v-if="!discountRequirement.contract.filename">
												jpg/png/pdf图片
											</p>
										</div>
									</div>
								</div>
								<div class="df fDC mt5">
									<Input
										v-model="discountRequirement.contract.pactAmount"
										placeholder="合同金额"
										@keyup.native="
											({ target }) => {
												discountRequirement.contract.pactAmount = target.value
													? target.value.replace(/[^0-9]/g, '')
													: '';
											}
										"
										@on-blur="
											({ target }) => {
												discountRequirement.contract.pactAmount = target.value
													? target.value.replace(/[^0-9]/g, '')
													: '';
											}
										"
										class="w200"
										maxlength="30"
									>
										<template #prepend>
											<span>合同金额</span>
										</template>
									</Input>
									<Input
										v-model="discountRequirement.contract.buyCompanyName"
										placeholder="买方名称"
										class="w200"
										maxlength="30"
									>
										<template #prepend>
											<span>买方名称</span>
										</template>
									</Input>
								</div>
							</div>
						</div>
						<div class="ml20 ">
							<p>发票</p>
							<Divider class="w100b mt10"></Divider>
							<div class="maxw550 ">
								<div class="fStart invoice_bg ">
									<div
										v-for="(item, index) in discountRequirement.invoice"
										:key="index"
										class=" df fDC"
									>
										<div class="dCC invoice-item  w200 h200">
											<div class="invoice_upload" style="width:200px">
												<div
													class="agreement_upload "
													v-if="item.filename"
												></div>
												<img
													:src="item.fileUrl"
													alt=""
													v-else-if="item.fileUrl"
												/>
												<div
													v-else
													class="imgUploadBg"
													@click="
														imgUploadClick(`imgUpload${index}`, 'img', index)
													"
												></div>
												<imgUpload
													:params="{
														ocr: false,
														loadding: false,
														isShowImg: true,
														isReUpload: false,
													}"
													:ref="`imgUpload${index}`"
													@change="imgUploadChange"
													:width="'42px'"
													:height="'48px'"
													v-show="!item.fileUrl"
													:format="['pdf', 'jpg', 'jpeg', 'png']"
													class="imgUploadBg dn"
												/>
											</div>

											<div class=" f12 ">
												<p class="c000">
													{{ item.fileUrl ? "发票" : "发票图片" }}
													{{ index + 1 }}
												</p>
											</div>
											<div class="fStart aic  ">
												<Button
													size="small"
													class="agreement_upload_btn"
													@click="
														imgUploadClick(`imgUpload${index}`, 'img', index)
													"
												>
													{{ item.fileUrl ? "重新上传" : "上传" }}
												</Button>
												<Button
													size="small"
													@click="invoiceDel(index)"
													class="delete_invoice ml10"
													><span class="delete_btn"></span
												></Button>
											</div>
											<div class=" f12 ">
												<p v-if="!item.fileUrl" class="c666">
													jpg/png/pdf图片
												</p>
											</div>
										</div>
										<div class="df fDC mt5">
											<Input
												v-model="item.pactAmount"
												placeholder="发票金额"
												@keyup.native="
													({ target }) => {
														item.pactAmount = target.value
															? target.value.replace(/[^0-9]/g, '')
															: '';
													}
												"
												@on-blur="
													({ target }) => {
														item.pactAmount = target.value
															? target.value.replace(/[^0-9]/g, '')
															: '';
													}
												"
												class="w200"
												maxlength="30"
											>
												<template #prepend>
													<span>发票金额</span>
												</template>
											</Input>
											<Input
												v-model="item.buyCompanyName"
												placeholder="买方名称"
												class="w200"
												maxlength="30"
											>
												<template #prepend>
													<span>买方名称</span>
												</template>
											</Input>
										</div>
									</div>

									<div
										class="dCC w200 h200 invoiceAdd_bg"
										style="flex:1;width:200px"
									>
										<div class="tc">
											<div class="invoiceAdd_inner cp" @click="invoiceAdd">
												<div class="invoiceAdd"></div>
											</div>
											<div class=" f12 mt10">
												<p>追加发票</p>
											</div>
											<Button
												class="invoice_btn "
												size="small"
												@click="invoiceAdd"
											>
												+ 追加
											</Button>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
				<div class="df aic m0a h100 jcc">
					<Button
						type="primary"
						style="border-radius:20px;"
						class="mr10 w200"
						@click="nextBtnEvent"
						>提交审核</Button
					>
					<Button style="border-radius:20px;" @click="reUpload"
						>取消贴现</Button
					>
				</div>
			</div>
			<!-- 提交贸易背景资料审核中 -->
			<div v-if="code == 12" class="bs2 mb20 bgfff tl">
				<div class="dCC h400 ">
					<Icon
						v-if="whlhDocumentLoading"
						type="ios-loading"
						size="60"
						class="demo-spin-icon-load mb20"
					></Icon>
					<Icon v-else type="ios-time" class="dp-c-waite f90 mb20" />
					<p class="mt5">贸易背景资料审核中</p>
					<Button class="mt20" @click="syncWhlh">刷新</Button>
				</div>
			</div>
			<!-- 蓝海贸易背景资料审核结果 -->
			<div v-if="code == 13" class="bs2 mb20 bgfff tl">
				<div v-if="examineDocStatus == 'SUCCESS'" class="dCC">
					<div class="dCC h300 ">
						<Icon type="ios-checkmark-circle" class="f102" />
						<p>贸易背景资料审核成功</p>
						<p class="f16">
							本次增加额度：{{
								formatMoney(
									Number(examineDtoAmount.contractAmountLimit).add(
										examineDtoAmount.invoiceAmountLimit
									),
									2,
									""
								)
							}}
						</p>
					</div>
					<div class="h100 mt30 ">
						<Button class=" w200" type="primary" @click="nextBtnEvent"
							>确认，前往网银贴现</Button
						>
						<Button class=" ml10" @click="findTotalAmount">查询额度总量</Button>
						<Button style="" class="ml10" @click="reUpload">取消订单</Button>
					</div>
				</div>
				<div v-else-if="examineDocStatus == 'FAIL'" class="dCC">
					<div class="dCC h300 ">
						<Icon type="ios-close-circle" class="f102  mb20" />
						<p>贸易背景资料审核失败</p>
						<p>
							失败原因：{{
								allParam.discountData.discountSyncOrderDto
									.discountSyncOrderWhlhDto.contractAuditFailReason ||
									allParam.discountData.discountSyncOrderDto
										.discountSyncOrderWhlhDto.invoiceAuditFailReason
							}}
						</p>
					</div>
					<div class="h100">
						<Button class="  mr20" type="primary" @click="syncWhlh"
							>重新校验</Button
						>
						<Button class=" w200 mr20" type="primary" @click="nextBtnEvent"
							>重新提交</Button
						>
						<Button style="border-radius:20px;" @click="reUpload"
							>取消订单</Button
						>
					</div>
				</div>
				<div v-else-if="examineDocStatus == 'AUDIT'" class="dCC">
					<div class="dCC h300 ">
						<Icon type="ios-time" class="dp-c-waite f90 mb20" />
						<p>贸易背景资料审核中</p>
					</div>
					<div class="h100">
						<Button class="  mr20" type="primary" @click="syncWhlh"
							>重新校验</Button
						>
						<Button class="w200  mr20" type="primary" @click="nextBtnEvent"
							>重新提交</Button
						>
						<Button style="border-radius:20px;" @click="reUpload"
							>取消订单</Button
						>
					</div>
				</div>
			</div>
			<!-- 富民贸易背景资料审核结果 -->
			<div v-if="code == 15" class="bs2 mb20 bgfff tl">
				<div v-if="examineDocStatus == 'SUCCESS'" class="dCC">
					<div class="dCC h300 ">
						<Icon type="ios-checkmark-circle" class="f102" />
						<p>贸易背景资料审核成功</p>
					</div>
					<div class="h100 mt30 ">
						<Button class=" w200" type="primary" @click="nextBtnEvent"
							>下一步，核对额度</Button
						>
					</div>
				</div>
				<div v-else-if="examineDocStatus == 'FAIL'" class="dCC">
					<div class="dCC h300 ">
						<Icon type="ios-close-circle" class="f102  mb20" />
						<p>贸易背景资料审核失败</p>
						<p>
							失败原因：{{
								allParam.discountData.discountSyncOrderDto
									.discountSyncOrderFuminDto.auditStatusDesc ||
									allParam.discountData.discountSyncOrderDto
										.discountSyncOrderFuminDto.auditStatusDesc
							}}
						</p>
					</div>
					<div class="h100">
						<Button class="  mr20" type="primary" @click="syncFM"
							>重新校验</Button
						>
						<Button class=" w200 mr20" type="primary" @click="nextBtnEvent"
							>重新提交</Button
						>
						<Button style="border-radius:20px;" @click="reUpload"
							>取消订单</Button
						>
					</div>
				</div>
				<div v-else-if="examineDocStatus == 'WAIT'" class="dCC">
					<div class="dCC h300 ">
						<Icon type="ios-time" class="dp-c-waite f90 mb20" />
						<p>贸易背景资料待审核</p>
					</div>
					<div class="h100 df aic">
						<Button class="mr20 w100" @click="syncFM">刷新</Button>
						<Button style="border-radius:20px;" @click="reUpload"
							>取消订单</Button
						>
					</div>
				</div>
			</div>
		</div>

		<!--图片弹框-->
		<div class="popups_style popupsEvent" v-if="showImgData.showImgStatus">
			<div class="pa w100b h100b df aic jcc">
				<!--上一步-->
				<div class="w66">
					<Icon
						type="ios-arrow-back"
						class="dp-icon-button-style"
						v-if="showImgData.index + 1 > 1"
						@click="img_move('left')"
					/>
				</div>
				<div class="df fDC aic jcc p30 bgfff mw350 pr">
					<!--关闭按钮-->
					<Icon
						type="md-close close_style"
						class="f18 c999 cp bgfff"
						@click="close_show_img"
					/>
					<div class="df">
						<div class="mr20 dp-w-show-text tl">
							<div class="bbDDD mb10">
								<template v-if="!showImgData.stepDes">
									<span class="f30 dp-c-primary">{{
										code4Param.activeBankOpration[0].stepStatus == "other"
											? showImgData.index
											: showImgData.index + 1
									}}</span>
									<span class="ccc f24"
										>/{{
											code4Param.activeBankOpration[0].stepStatus == "other"
												? showImgData.step - 1
												: showImgData.step
										}}</span
									>
								</template>
								<span class="f30 dp-c-primary" v-else>{{
									showImgData.stepDes
								}}</span>
							</div>
							<div class="f14" v-html="showImgData.content"></div>
						</div>
						<div class="dp-bg-img df dp-h-show-img dp-w-show-img">
							<div
								class="f1 oya scroll-style p10"
								v-if="showImgData.showImgUrl"
							>
								<img
									:src="bank_discount_img(showImgData.showImgUrl)"
									:alt="showImgData.showImgUrl"
									class="f00a w100b"
								/>
							</div>
							<div class="f1 df fDC aic jcc" v-else>
								<template v-if="showImgData.stepDes == '网银怎么提票？'">
									<i class="dp-default-img2"></i>
								</template>
								<template v-else>
									<i class="w50 h40 mb16 dp-default-img"></i>
									<div class="f14 dp-c-no-img-img">此处无图</div>
								</template>
							</div>
						</div>
					</div>
				</div>
				<!--下一步-->
				<div class="w66">
					<Icon
						type="ios-arrow-forward"
						class="dp-icon-button-style"
						v-if="showImgData.index + 1 < showImgData.step"
						@click="img_move('right')"
					/>
				</div>
			</div>
		</div>
		<!-- 华润微信小程序二维码弹框 -->
		<!-- <div class="popups_style popupsEvent" v-if="showHuarunQRCodeImg.showImg">
      <div class="pa w100b h100b df aic jcc">
        <div class="df fDC aic jcc p30 bgfff w654 mh300 pr tc">
          <div class="mt10 mb10 fb f20 ls1">扫描下方二维码开始贴入“华润银行”</div>
          <div class="mb10">华润银行在线贴现业务由“润秒贴”小程序提供服务</div>
          <div>
            <img class="w60b" :src="showHuarunQRCodeImg.url" alt="华润银行小程序二维码">
          </div>
          <div class="mt13 mb10 dCC">
            <Button class="w80" @click="close_show_huarunCode">关闭</Button>
          </div>
        </div>
      </div>
    </div> -->

		<!-- 华润银行签约引导 微信小程序二维码弹框 -->
		<Modal
			:mask-closable="false"
			v-model="showHuarunBankSign.showType"
			width="770"
			class="pass_modal  huarun_modal modal-footer-p0"
			:footer-hide="true"
		>
			<!--重写顶部-->
			<p slot="header" class="tc c000">
				<span>签约华润银行</span>
			</p>
			<!--进度条-->
			<div>
				<ul class="fStart step">
					<li v-for="(item, index) in showHuarunBankSign.stepArr" :key="index">
						<div class="step-item" v-if="index < 5">
							<div class="top">
								<span
									:class="['step-node', 'step-node-active']"
									v-if="index === 0"
								>
								</span
								><span
									:class="['step-line', item.active ? 'step-line-active' : '']"
								></span>
								<span
									:class="['step-node', item.active ? 'step-node-active' : '']"
									v-if="index >= 0"
								></span>
							</div>
						</div>
					</li>
				</ul>
				<ul class="fSpace step">
					<li v-for="(item, index) in showHuarunBankSign.stepArr" :key="index">
						<div class="" v-if="index === 0">
							<div :class="['step-text', 'step-text-active']">
								{{ item.stepText }}
							</div>
						</div>
						<div
							class=""
							v-else-if="
								index === 5 && showHuarunBankSign.stepArr[index - 1].active
							"
						>
							<div :class="['step-text', 'step-text-active']">
								{{ item.stepText }}
							</div>
						</div>
						<div class="" v-else-if="index > 0">
							<div
								:class="[
									'step-text',
									showHuarunBankSign.stepArr[index - 1].active
										? 'step-text-active'
										: '',
								]"
							>
								{{ item.stepText }}
							</div>
						</div>
					</li>
				</ul>
			</div>
			<div class="pt20 ">
				<div class="fRowCenter h337" v-if="showHuarunBankSign.code === 1">
					<div class="wechat_QR">
						<div class="df aic jcc mt20 c333 f12">
							<span class="wechat_fill dl mr10"></span> 微信扫一扫
						</div>
						<div class="df fDC aic jcc mt40">
							<img
								:src="showHuarunBankSign.HuarunQrCode"
								alt=""
								class="w180 h180 "
							/>
						</div>
					</div>
				</div>
				<div class="fStart h337" v-if="showHuarunBankSign.code === 2">
					<div class="w100b  tc">
						<img src="~@/assets/img/applicationDiscount/B_zhuce.png" alt="" />
					</div>
				</div>
				<div class="fStart h337" v-if="showHuarunBankSign.code === 3">
					<div class="w100b  tc">
						<img
							src="~@/assets/img/applicationDiscount/c_caozuoxinxi.png"
							alt=""
						/>
					</div>
				</div>
				<div class="fStart h337" v-if="showHuarunBankSign.code === 4">
					<div class="w100b  tc">
						<img src="~@/assets/img/applicationDiscount/d_xieyi.png" alt="" />
					</div>
				</div>
				<div class="fStart h337" v-if="showHuarunBankSign.code === 5">
					<div class="w100b  tc">
						<img src="~@/assets/img/applicationDiscount/e-gudong.png" alt="" />
					</div>
				</div>
				<div class="dCC h337" v-if="showHuarunBankSign.code === 6">
					<div class="w100b  tc c333 ">
						<img
							src="~@/assets/img/applicationDiscount/icon_shenhetijiao.png"
							alt=""
							class=""
						/>
						<p class="f18 fb ">您的签约审核已提交</p>
						<p class="mb20 mt5">您的签约结果将通过短信方式通知操作人</p>
						<div class="df jcc">
							<p class="w300 tc">
								由于银行签约、建额需要时间，感谢您的耐心等待如急需贴现可“申请客服协助”
							</p>
						</div>
					</div>
				</div>
			</div>
			<!--重写底部-->
			<div class="fRowCenter plr30  h30 aic mt20">
				<div v-if="showHuarunBankSign.code < 6">
					<Button
						type="primary"
						class="mr10"
						v-if="showHuarunBankSign.code !== 1"
						@click="HuaRunPreBtenEvent()"
						>上一步</Button
					>
					<Button type="primary" @click="HuaRunNextTick()">下一步</Button>
				</div>
				<div v-else>
					<Button
						type="primary"
						class="mr10"
						@click="showHuarunBankSign.showType = false"
						>我知道了</Button
					>
					<Button @click="handleCustomerBtn()">申请客服协助</Button>
				</div>
			</div>
		</Modal>
		<!--弹框-->
		<Modal
			:mask-closable="false"
			v-model="code1Param.accountModal"
			width="770"
			class="pass_modal modal-footer-p0"
		>
			<!--重写顶部-->
			<p slot="header" class="tc cfff">
				<span>请选择您的票据所在公司</span>
			</p>
			<div class="plr15 pt5 mb35">
				<div class="c666 f16 mb15">请确保您要贴现的票据在所选的公司名下</div>
				<ul>
					<li
						class="hl55 f14 pl10 mb15 br4"
						v-for="item in code1Param.canDiscountAcct"
						:class="[
							allParam.discountAcctDto.id == item.id
								? 'ul-list-active'
								: 'ul-list',
						]"
						@click="allParam.discountAcctDto = item"
					>
						{{ item.corpName }}
					</li>
				</ul>
				<router-link to="/SilverTicketManage">
					<div class="tc hl55 bccc c0077DA cp">开通新公司+</div>
				</router-link>
			</div>
			<!--重写底部-->
			<div slot="footer" class="fSpace plr30 bgFBFBFB h120 aic">
				<div class="tl">
					<p class="c666 mb5">
						您将使用<span class="fb"
							>“{{ allParam.discountAcctDto.corpName }}”</span
						>
					</p>
					<p class="c666">「票据所在对公账户」进行贴现</p>
				</div>
				<Button type="primary" @click="queryBankRate()">确认，开始贴现</Button>
			</div>
		</Modal>

		<!-- 网商银行弹框 -->
		<Modal
			id="network"
			:mask-closable="false"
			v-model="code2Param.networkModel"
			:closable="false"
			width="770"
			footer-hide
		>
			<div class="pr pt68 pb40 plr20 ">
				<Button
					class="close pa t0 r5"
					type="text"
					@click="code2Param.networkModel = false"
				>
					<Icon color="#A11C1C" size="20" type="md-close" />
				</Button>

				<div class="fSpace">
					<div class="w270 mr20">
						<p class="c666 mb17">网商银行在线贴现简介：</p>

						<div class="h356 bccc bgFBFBFB dCC plr25">
							<p>
								<img
									height="80"
									src="~@/assets/img/applicationDiscount/logo@2x.png"
									alt=""
								/>
							</p>
							<p class="mt36 w100b">
								网商银行在线贴现开通成功后，依据登录快贴宝后查得的报价，即可通过其他任意银行企业网银在线向网商银行发起贴现申请，贴现成功后一般15秒内放款。
							</p>
						</div>
					</div>

					<div class="w443">
						<p class="c666 mb17">操作方法：</p>

						<div class="h356 bccc bgFBFBFB fSpace ptb15 plr40">
							<p>
								<img
									width="143px"
									src="~@/assets/img/applicationDiscount/iphonex@2x.png"
									alt=""
								/>
							</p>

							<div class="fCSpace">
								<div class="bgfff b333 pr bablock networkTip">
									<p class="f16">打开支付宝</p>
									<div class="fStart">
										<img
											width="42px"
											height="42px"
											src="~@/assets/img/applicationDiscount/sys@2x.png"
											alt=""
										/>
										<p class="c027AFF ml10 l20 f18">
											使用扫一扫功能<br />扫描下方二维码
										</p>
									</div>
									<p class="f16">
										进入<span class="c2FAFB3">网商银行在线快贴</span>
									</p>
								</div>
								<div ref="qrcode" id="qrcode" class="wh200"></div>
							</div>
						</div>
					</div>
				</div>

				<p class="c666 tc mt20">
					不会使用？即刻联系<span
						@click="handleCustomerBtn()"
						class="c0077DA cp"
						>在线客服</span
					>
				</p>
			</div>
		</Modal>

		<!-- 威海蓝海-JD 上传贸易背景资料嵌入 -->
		<Modal
			:mask-closable="false"
			v-model="JDModal"
			width="80%"
			class="p10"
			@on-ok="JDModalVisbleChange"
		>
			<iframe
				id="bi_iframe"
				width="100%"
				height="650px"
				:src="JDUploadUrl"
				scrolling="auto"
				@onload="adjustIframe"
				frameborder="0"
			></iframe>
		</Modal>
	</div>
</template>

<script>
import imgUpload from "@/components/module/imgUpload";

import store from "@/store/store";
// import $ from "jquery";
import qrCode from "qrcodejs2";
import "viewerjs/dist/viewer.css";
import Viewer from "viewerjs";
import { nextTick } from "vue";

let _this = "";

export default {
	store, // 引用
	name: "homeMenu",
	components: {
		imgUpload,
	},
	data() {
		return {
			depositRate: [], // 存款利率

			bottomImg: {}, // 底部广告位

			isTabTrue: true,
			label: (h) => {
				return h("div", [
					h("p", "上传承兑汇票正面图片"),
					h(
						"p",
						{
							style: {
								color: "#999",
								fontSize: "14px",
							},
						},
						"自动识别票面信息"
					),
				]);
			},
			label1: (h) => {
				return h("div", [h("p", "手动输入承兑汇票信息")]);
			},

			code: 1, // 步骤
			current: 0, // 步骤进度条
			whlhselfCode: 0,

			allParam: {
				userId: this.$store.state.userId, // 用户id

				ocrTimer: "",

				billBase64: "", // 上传票面的base64格式
				billFile: "", // 票据图片
				billFileEtag: "", // 票据图片oss上次响应etag

				billNo: "", // 票号
				billNoTip: false, // 票号提示
				billAmount: "", // 票面金额
				billAmountSupper: "", // 票面金额-大写
				acceptorBankNum: "", // 承兑行行号
				acceptorBankNumTip: false, // 承兑行行号提示
				acceptorBankName: "", // 承兑行名称
				dueDate: "", // 到期日期，格式：yyyy-MM-dd
				dueDays: "", // 到期天数

				servicePrice: "", // 服务费余额-服务费

				discountAcctDto: {}, // 账户信息

				discountData: {}, // code2 选择的贴入银行数据
			},
			chooseAccount: {},

			code1Param: {
				tableCurrent: 1, // 当前的tab标签栏的选择

				nextStatus: false, // 是否可以点击下一步

				msgTip: "", // 提示
				msgTipCss: "", // 提示的样式

				ocrLoading: false, // ocr识别loading

				accountModal: false, // 是否展示选择账户的弹框
				canDiscountAcct: [], // 可以贴现的账户数据
				acctNormal: [], // 账户状态是正常的账户列表
			},

			code2Param: {
				// table数据
				table1: {
					columns14: [
						{
							title: "Date",
							slot: "name",
							align: "center",
							width: 100,
							tooltip: true,
							ellipsis: true,
						},
						{
							title: "Name",
							slot: "key",
							align: "left",
							tooltip: true,
							ellipsis: true,
						},
						{
							title: "Age",
							slot: "sum",
							align: "left",
							tooltip: true,
							ellipsis: true,
						},
					],
					data5: [],
					header: false,
				},

				rateBtn: true, // 选择排序

				discountBankList: [], // 询价出来的可贴现的银行
				orderId: "", // 订单id

				networkModel: false,
			},

			code4Param: {
				left: 0, // 向左滑动的距离

				bankList: [], // 银行列表
				activeBankCode: "HS", // 当前选择的银行
				activeBankOpration: "", // 当前选择的银行操作列表

				// 银行操作列表
				bankOperationList: {
					HS: [
						{
							content:
								"登录徽商银行金融服务平台，点击进入“发起申请”， 选择要背书的票据",
						},
						{
							imgUrl: "huishangbank_b@2x.png",
							content: "选择好要贴现的票据以后，进行“贴现申请”",
						},
						{
							imgUrl: "huishangbank_c@2x.png",
							content: "信息核对无误以后点击“提交”，等待复核",
						},
						{
							imgUrl: "huishangbank_d@2x.png",
							content: "在网站“待办事项”里查看是否需要复核",
						},
						{
							imgUrl: "huishangbank_e@2x.png",
							content: "进入复核界面，核对相关信息，并点击“复核”",
						},
						{
							imgUrl: "huishangbank_f@2x.png",
							content: "添加“复核意见”，点击确认",
						},
					],
					MS: [
						{
							imgUrl: "minshengbank_a@2x.png",
							content:
								"登录民生银行企业网上银行，点击“票据-贴现”，选择所要贴现的票据，注意图片内的提示",
						},
						{
							imgUrl: "minshengbank_b@2x.png",
							content:
								"选择好贴现的票据后，核对信息并提交，提交后，核对票据 信息并点击“确认” ",
						},
						{
							imgUrl: "minshengbank_c@2x.png",
							content:
								"登录网站首页，查看交易待办任务，选择需要审核的交易，查看业务是否确认",
						},
					],
					NJ: [
						{
							imgUrl: "nanjingbank_a@2x.png",
							content:
								"登录南京银行企业网上银行的官网，登录后点击“票据业务-贴现”，并核对所需贴现的票据信息。",
						},
						{
							imgUrl: "nanjingbank_b@2x.png",
							content: "对贴现的票据信息进行检查，确认无误后，点击“确认”",
						},
						{
							imgUrl: "nanjingbank_c@2x.png",
							content: "提交后等待银行处理，在电子票据查询-指令查询里查看详情",
						},
					],
					NB: [
						{
							imgUrl: "ningbobank_a@2x.png",
							content:
								"登录宁波银行企业网上银行选择“票据好管家-电子银行承 兑汇票-贴现申请-快速贴现”，选择想要贴现的票据点击“贴现申请”",
						},
						{
							imgUrl: "ningbobank_b@2x.png",
							content:
								"填写贴现利率、贴入银行等必填信息，可直接搜索填入银行以及收款银行",
						},
						{
							imgUrl: "ningbobank_c@2x.png",
							content: "核对信息并提交，等待反馈",
						},
					],
					XY: [
						{
							imgUrl: "xingyebank_a@2x.png",
							content: "登录兴业银行企业网上银行，点击“商业银行-贴现-贴现申请”",
						},
						{
							imgUrl: "xingyebank_b@2x.png",
							content:
								"查询所要贴入的银行，选择要贴现的票据，填写相关信息并提交。并在票据业务处理结果查询里查询",
						},
						{
							imgUrl: "xingyebank_c@2x.png",
							content: "点击“客户服务-待办事宜”查询待办指令。",
						},
						{
							imgUrl: "xingyebank_d@2x.png",
							content:
								"点击“商业汇票-人行电子商业汇票-票据指令授权”，选择需要授权的指令。并输入网盾密码，点击网盾上“OK”",
						},
						{
							imgUrl: "xingyebank_e@2x.png",
							content: "结束",
						},
					],
					ZS: [
						{
							imgUrl: "zhaoshangbank_a@2x.png",
							content:
								"登录招商银行企业银行，点击“票据大管家-票据融资-票据贴现经办”",
						},
						{
							imgUrl: "zhaoshangbank_b@2x.png",
							content:
								"点击“增加”，查询要贴现的票据信息，核对相关信息，确认无误后点击“经办”",
						},
					],
					PA: [
						{
							imgUrl: "pinganbank_a@2x.png",
							content:
								"进入平安银行企业网上银行，点击“票据业务-电子票据-贴现-贴现申请”，根据网页上的信息填写，最后点击贴现申请",
						},
					],
					ZX: [
						{
							imgUrl: "zhongxinbank_a@2x.png",
							content: "注意:实付金额要点计算，如果遇到周末节假日要填在途天数",
						},
					],
					ZG: [
						{
							imgUrl: "zhongguobank_a@2x.png",
							content: "按照图中指示，进行贴现操作(*为必填项)",
						},
					],
					JT: [
						{
							imgUrl: "jiaotongbank_a@2x.png",
							content: "选中票据",
						},
						{
							imgUrl: "jiaotongbank_b@2x.png",
							content: "填写利率",
						},
						{
							imgUrl: "jiaotongbank_c@2x.png",
							content: "提交信息",
						},
					],
					CS: [
						{
							imgUrl: "changshabank_a@2x.png",
							content: "",
						},
					],
					GF: [
						{
							imgUrl: "guanggabank_a@2x.png",
							content: "",
						},
					],
					MT: [
						{
							imgUrl: "zhejiangmintaibank_a@2x.png",
							content: "",
						},
					],
					TL: [
						{
							imgUrl: "zhejiangtailongshangyebank_a@2x.png",
							content: "",
						},
					],
					NY: [
						{
							imgUrl: "zhongguonongyebank_a@2x.png",
							content: "",
						},
					],
					HZ: [
						{
							imgUrl: "hangzhoubank_a@2x.png",
							content: "",
						},
					],
					NS: [
						{
							imgUrl: "wulumuqnongshangbank_a@2x.png",
							content: "",
						},
					],
					PF: [
						{
							imgUrl: "pufabank_a@2x.png",
							content: "",
						},
					],
					GS: [
						{
							imgUrl: "zhongguogongshangbank@2x.png",
							content: "",
						},
					],
					JS: [
						{
							imgUrl: "zhongguojianshebank_a@2x.png",
							content:
								"建行贴现请选择电子商业汇票系统，请不要选择票据池，否则无法成功提票",
						},
					],
					SJ: [
						{
							imgUrl: "shengjingbank_a@2x.png",
							content: "",
						},
					],
					CZ: [
						{
							imgUrl: "zheshangbank_a@2x.png",
							content: "",
						},
					],
					QX: [
						{
							imgUrl: "shanxiqingchunongcunbank_a@2x.png",
							content: "",
						},
					],
					JH: [
						{
							imgUrl: "jinhuabank_a@2x.png",
							content: "",
						},
					],
					ZY: [
						{
							imgUrl: "zhongyuanbank_a@2x.png",
							content: "",
						},
					],
					HX: [
						{
							imgUrl: "huaxiabank_a@2x.png",
							content: "",
						},
					],
					NCSY: [
						{
							imgUrl: "chongqingnongcunshangyebank_a@2x.png",
							content: "",
						},
					],
					CJSY: [
						{
							imgUrl: "jiangsuchangjiangshangyebank_a@2x.png",
							content: "",
						},
					],
					YZ: [
						{
							imgUrl: "youzhengbank_a@2x.png",
							content: "",
						},
					],
					GD: [
						{
							imgUrl: "zhongguoguangdabank_a@2x.png",
							content: "登录光大银行网上银行，点击“商业汇票-贴现申请-新增批次”",
						},
						{
							imgUrl: "zhongguoguangdabank_b@2x.png",
							content: "点击“添加票据”选择需要提交的票据",
						},
						{
							imgUrl: "zhongguoguangdabank_c@2x.png",
							content: "点击“交易审核-电子票据交易审核”",
						},
						{
							imgUrl: "zhongguoguangdabank_d@2x.png",
							content: "如果票据提交错误，也可以进行找回",
						},
					],
					ZY2: [
						{
							imgUrl: "zhongyuanbank_b_a@2x.png",
							content: "",
						},
					],
					JT2: [
						{
							imgUrl: "jiaotongbank_b_a@2x.png",
							content: "",
						},
					],
				},

				moreShowStatus: false, // 更多的弹框是否展示
			},

			// 查看图片的数据
			showImgData: {
				showImgStatus: false, // 是否展示图片的弹框
				showImgUrl: "", // 展示的图片的地址
				content: "", // 描述内容
				index: 1, // 第几步
				step: 6, // 总共的步骤
			},
			isHUARUNFinsh: false, // 判断订单页跳转过来的华润订单 去引导小程序获取帖凭
			stepImge: 0, // 操作网银步骤图片索引
			// 华润银行签约弹框
			showHuarunBankSign: {
				code: 1,
				showType: false, // 是否展示模态框
				HuarunQrCode: "",
				stepArr: [
					{
						active: false,
						stepText: "1.扫码进入小程序",
					},
					{
						active: false,
						stepText: "2.注册/登录",
					},
					{
						active: false,
						stepText: "3.操作人信息验证",
					},
					{
						active: false,
						stepText: "4.协议及企业基础信息",
					},
					{
						active: false,
						stepText: "5.股东信息及法人授权",
					},
					{
						active: false,
						stepText: "签约审核",
					},
				],
			},
			// // 华润二维码弹框地址
			// showHuarunQRCodeImg: {
			//   url: '',
			//   showImg: false
			// }
			// 蓝海下单前上传合同及发票
			discountRequirement: {
				contract: {
					filename: "",
					fileUrl: "",
					pactAmount: "",
					buyCompanyName: "",
					loading: false,
				}, // 合同
				invoice: [
					{
						filename: "",
						fileUrl: "",
						pactAmount: "",
						buyCompanyName: "",
						loading: false,
					},
				], // 发票列表
				invoiceTemplateFile: { filename: "", fileUrl: "", loading: false },
			},
			whlhDocumentLoading: false,
			isInvoiceUploaded: false,
			// 子票区间码
			billSubStatus: false,
			billSubNo1: "",
			billSubNo2: "",

			//
			invoiceType: "01",
			// 蓝海合同发票剩余额度
			examineDtoAmount: {
				state: "",
				rejectReason: "",
				amountLimit: null,
				liftAmountLimitState: null,
				liftAmountLimit: null,
				contractAmountLimit: null,
				invoiceAmountLimit: null,
			},
			// 蓝海前手资料
			frontCertName: "",
			// 蓝海提交贸易背景资料审核状态
			examineDocStatus: "",
			// 蓝海传前手资料时是否展示合同审核的按钮
			isShowWhlhDtoBtn: false,
			//  威海蓝海 京东上传贸易背景资料
			JDModal: false,
			JDUploadUrl: "",
			isShowJDProcess: false,
			showJDProcessTextCode: {
				"40": "未上传",
				"20": "审核中",
				"21": "审核成功",
				"30": "银行拒绝签收",
			},
		};
	},
	computed: {
		isFiled() {
			if (this.allParam.discountData.discountChannel === "WHLH") {
				return (
					this.discountRequirement.contract.fileUrl ||
					this.discountRequirement.invoice.some((item) => item.fileUrl)
				);
			} else {
				return (
					this.discountRequirement.contract.fileUrl &&
					this.discountRequirement.invoice.some((item) => item.fileUrl)
				);
			}
		},
		// 判断蓝海合同发票审核状态
	},
	methods: {
		// 富民渠道富民银行签约极速贴
		uploadFMTip(type) {
			if (type === "MYSELF") {
				// 富民渠道富民银行签约极速贴
				this.showTip({
					tipMessage:
						"<div class='fb '>您上传的票面大于500万元<br/>如需贴现请提交富民银行补充资料</div>", // 提示信息
					tipLogo: "tip_prompt", // 提示logo
					tipButtonLeft: "暂不提交", // 左按钮名称
					tipButtonLeftType: "default", // 左按钮的类型
					tipButtonRight: "立即提交资料", // 右按钮名称
					tipButtonRightType: "primary", // 右按钮类型
					tipButtonLeftCall: function() {
						_this.hidePopus();
					}, // 左按钮回调
					tipButtonRightCall: function() {
						_this.hidePopus();
						_this.$router.push("/SilverTicketManage");
					}, // 右按钮回调
					title: "提示", // 顶部title
					bottomCall: function() {
						// 客服
						_this.handleCustomerBtn();
					},
					bottom: '<span class="cp dl mt10 c005FFF">申请客服帮助</span>',
				});
			} else {
				// 京东富民银行提示
				this.showTip({
					tipMessage:
						"<div class='fb '>您上传的票面大于500万元<br/>如需贴现请联系客服</div>", // 提示信息
					tipLogo: "tip_prompt", // 提示logo
					tipButtonLeft: "暂不提交", // 左按钮名称
					tipButtonLeftType: "default", // 左按钮的类型
					tipButtonRight: "申请客服帮助", // 右按钮名称
					tipButtonRightType: "primary", // 右按钮类型
					tipButtonLeftCall: function() {
						_this.hidePopus();
					}, // 左按钮回调
					tipButtonRightCall: function() {
						// 客服
						_this.handleCustomerBtn();
					}, // 右按钮回调
					title: "提示", // 顶部title
				});
			}
		},
		// 初始化-查看订单详情
		handleDetail(id) {
			// 查看详情
			this.sendGet(
				{
					url: `/web/discount-order/${id}`,
					tip: false,
				},
				(result) => {
					Object.assign(
						this.allParam.discountData,
						result.data.data,
						result.data.data.discountSyncOrderDto
					);
					Object.assign(
						this.allParam.discountAcctDto,
						result.data.data.discountAcctDto
					);
					if (
						this.allParam.discountData &&
						this.allParam.discountData.bankCode === "HUARUN"
					) {
						this.handleCode4Param();
						this.code = 4;
						this.current = 2;
					} else if (
						this.allParam.discountData.discountChannel === "WHLH" ||
						this.allParam.discountData.discountChannel === "fumin"
					) {
						this.handleCode4Param();
						this.code = 4;
						this.current = 2;
						this.showDtoBtn();
					} else {
						this.code = 5;
						this.checkOrderInfo();
					}
				}
			);
		},

		adjustIframe() {
			var ifm = document.getElementById("bi_iframe");
			ifm.height = document.documentElement.clientHeight;
			ifm.width = document.documentElement.clientWidth;
		},

		// 公共
		// 数据处理
		// true-整数
		handleNumber(str, isNum) {
			return isNum
				? str.replace(/[^\d.]/g, "").replace(".", "")
				: str.replace(/[^\d.]/g, "");
		},
		billNoNumber() {
			this.allParam.billNo = this.handleNumber(this.allParam.billNo, true);
		},
		billAmountNumber() {
			this.allParam.billAmount = this.handleNumber(this.allParam.billAmount);
		},
		acceptorBankNumNumber() {
			this.allParam.acceptorBankNum = this.handleNumber(
				this.allParam.acceptorBankNum,
				true
			);
		},

		// 优化对象赋值
		handleObj(arr, obj) {
			let newObj = {};

			arr.forEach((val) => {
				newObj[val] = obj[val] || "";
			});
			return newObj;
		},

		// 票据信息清空
		handleBill() {
			_this.allParam.ocrTimer ? clearTimeout(_this.allParam.ocrTimer) : "";
			Object.assign(
				_this.allParam,
				this.handleObj(
					[
						"billNo",
						"billAmount",
						"billAmountSupper",
						"acceptorBankNum",
						"acceptorBankName",
						"dueDate",
						"dueDays",
					],
					{}
				)
			);
		},

		// 检查登录
		checkLogin() {
			if (!this.fungetLogin()) {
				// 退出登录
				// console.log("退出登录")
				this.showLoginPopus();
				return false;
			}
			return true;
		},

		// 查看图片-弹框
		// 关闭大图弹框
		close_show_img: function() {
			this.showImgData.showImgStatus = false;
		},
		// 图片移动
		img_move: function(direction) {
			if (direction == "left") {
				// 左移
				this.showImgData.showImgUrl = this.code4Param.activeBankOpration[
					this.showImgData.index - 1
				].imgUrl;
				this.showImgData.content = this.code4Param.activeBankOpration[
					this.showImgData.index - 1
				].content;
				this.showImgData.stepDes = this.code4Param.activeBankOpration[
					this.showImgData.index - 1
				].stepDes;
				this.showImgData.index = this.showImgData.index - 1;
				this.showImgData.step = this.code4Param.activeBankOpration.length;
			} else {
				// 右移
				this.showImgData.showImgUrl = this.code4Param.activeBankOpration[
					this.showImgData.index + 1
				].imgUrl;
				this.showImgData.content = this.code4Param.activeBankOpration[
					this.showImgData.index + 1
				].content;
				this.showImgData.stepDes = this.code4Param.activeBankOpration[
					this.showImgData.index + 1
				].stepDes;
				this.showImgData.index = this.showImgData.index + 1;
				this.showImgData.step = this.code4Param.activeBankOpration.length;
			}
		},

		// 初始化复制按钮
		initBtnCopy() {
			this.myClipboard = new this.clipboard(".btnCopy");

			this.myClipboard.on("success", function(e) {
				_this.$Message.success("复制成功!");
				e.clearSelection();
			});
			this.myClipboard.on("error", function(e) {
				_this.$Message.info("请按 Ctrl+C 复制文字");
			});
		},

		// 图片路径
		bank_discount_img(url) {
			return "/static/img/img_bank_discount/" + url;
		},

		// // 华润弹框操作
		// showHuarunQRCode (row) {
		//   console.log(row);
		//   this.showHuarunQRCodeImg.showImg = true
		//   this.showHuarunQRCodeImg.url = row.huarunQrCode
		// },
		// 关闭华润弹框操作
		// close_show_huarunCode () {
		//   this.showHuarunQRCodeImg.showImg = false
		// },

		// 下一步按钮
		nextBtnEvent(row) {
			console.log(this.discountRequirement);
			switch (this.code) {
				case 1:
					this.addLoading();

					// 判断当前用户是否登录
					if (!this.fungetLogin()) {
						_this.$Message.error("请先登录，再进行询价");
						this.showLoginPopus();
						this.removeLoading();
						break;
					}

					// 判断信息是否补全
					if (
						this.allParam.billNo.length != 30 ||
						this.allParam.acceptorBankNum.length != 12
					) {
						// _this.$Message.error('票号不满30位');
						this.allParam.billNo.length != 30
							? (_this.allParam.billNoTip = true)
							: (_this.allParam.billNoTip = false);
						this.allParam.acceptorBankNum.length != 12
							? (_this.allParam.acceptorBankNumTip = true)
							: (_this.allParam.acceptorBankNumTip = false);
						this.removeLoading();
						break;
					}

					// 子票区间校验
					if (this.billSubStatus) {
						if (this.billSubNo1 && this.billSubNo2) {
							this.allParam.billSubNo = this.billSubNo1 + "-" + this.billSubNo2;
						} else if (this.billSubNo1 || this.billSubNo2) {
							_this.$Message.error("子票区间请填写完整");
							this.removeLoading();
							break;
						}
					}
					// 银票|商票票号判断调整
					if (this.allParam.billNo.split("")[0] == "2") {
						this.removeLoading();

						console.log(_this.allParam);

						this.showTip({
							title: "提示",
							tipClass: "w770 mb85",
							tipMessage: `<p class="f24 fb l25 mb20">检测到您上传的票据为商票，是否前往商票快贴</p>`, // 提示信息
							tipLogo: "tip_prompt mt96 mb20", // 提示logo

							tipButtonLeft: "是，立即前往", // 左按钮名称
							tipButtonLeftType: "primary", // 左按钮的类型
							tipButtonLeftCall: function() {
								// 将票号、票面金额、到期人、承兑人 信息带入了到另一个板块
								let toYPData = Object.assign(
									{},
									_this.handleObj(
										[
											"billBase64",
											"billNo",
											"billAmount",
											"dueDate",
											"dueDays",
											"acceptorBankName",
											"acceptorBankNum",
										],
										_this.allParam
									)
								);
								_this.$router.push({
									name: "BusinessTicketDiscount",
									query: toYPData,
								});

								_this.hidePopus();
							}, // 左按钮回调

							tipButtonRight: "否，暂不需要", // 右按钮名称
							tipButtonRightType: "default", // 右按钮类型
							tipButtonRightClass: "", // 右按钮类名
							tipButtonRightCall: function() {
								_this.hidePopus();
							}, // 右按钮回调
						});

						break;
					}

					// 查询账户列表
					this.sendGet(
						{
							url: "/trade-center/discount-acct",
							data: { userId: this.$store.state.userId, status: "SUCCESS" },
						},
						(result) => {
							this.code1Param.acctNormal = result.data.data; // 便于code 2 立即贴现判断
							this.code1Param.canDiscountAcct = [];
							// 存在账户
							if (result.data.data.length > 0) {
								// 查询已签约成功的账户
								result.data.data.forEach((item) => {
									item.statistics.creditSuccessQuantity &&
									item.statistics.creditSuccessQuantity > 0
										? this.code1Param.canDiscountAcct.push(item)
										: "";
								});

								// 存在账户-存在已签约成功的账户
								if (this.code1Param.canDiscountAcct.length > 0) {
									this.code1Param.accountModal = true; // 显示账户列表弹框

									// 默认选择第一个账户
									this.allParam.discountAcctDto = this.code1Param.canDiscountAcct[0];
									return false;
								}

								_this.handleAcctTip_qy(true); // 存在账户-不存在已签约成功的账户，提示进行签约

								return false;
							}

							_this.handleAcctTip_kh(true); // 不存在账户，提示进行开户
						}
					);

					/* // 查询账户是否欠费；欠费-提示，不欠费-查询账户列表
	         this.sendPut({
	           url: `/web/discount-order/settle?userId=${this.$store.state.userId}`,
	           tip: false, // false-显示loading, true-隐藏loading（默认）
	           successCallback: (result) => {
	             // 提示欠费
	             if (result.data.data.arrearsStatus == 1) {
	               this.showTip({
	                 tipMessage: `<div class='mb10'>您的服务费前处于欠款状态<br/>请您补足欠费后进行快贴询价</div><div class="fb f16 dp-c-warning">当前欠费${_this.formatMoney(result.data.data.chargeAmount)}</div>`, // 提示信息
	                 tipLogo: "tip_light", // 提示logo
	                 tipButtonLeft: "立即充值", // 左按钮名称
	                 tipButtonRight: "稍后充值", // 右按钮名称
	                 tipButtonLeftCall: function () {
	                   _this.hidePopus();
	                   _this.$router.push({ name: 'DiscountTrends', params: { toRecharge: true } });
	                 }, // 左按钮回调
	                 tipButtonRightCall: function () {
	                   _this.hidePopus();
	                 }, // 右按钮回调
	                 title: "提示", // 顶部title
	               });
	               _this.removeLoading();
	               return false;
	             }

	             // 不欠费，正常走下去-查询账户贴现列表
	             this.$store.state.user.userInfo.balance = result.data.data.userBalance;
	             this.sendGet({
	               url: '/web/discount-acct',
	               data: { userId: this.$store.state.userId }
	             }, (result) => {
	               this.code1Param.acctNormal = result.data.data; // 便于code 2 立即贴现判断
	               this.code1Param.canDiscountAcct = [];

	               // 存在账户
	               if (result.data.data.length > 0) {
	                 // 查询已签约成功的账户
	                 result.data.data.forEach((item) => {
	                   item.creditQuantity && item.creditQuantity > 0 ? this.code1Param.canDiscountAcct.push(item) : '';
	                 })

	                 // 存在账户-存在已签约成功的账户
	                 if (this.code1Param.canDiscountAcct.length > 0) {
	                   this.code1Param.accountModal = true; // 显示账户列表弹框

	                   // 默认选择第一个账户
	                   this.allParam.discountAcctDto = this.code1Param.canDiscountAcct[0];
	                   return false;
	                 }

	                 _this.handleAcctTip_qy(true); // 存在账户-不存在已签约成功的账户，提示进行签约

	                 return false;
	               }

	               _this.handleAcctTip_kh(true);  // 不存在账户，提示进行开户
	             })
	           }
	         }) */
					break;

				case 2:
					// 网商银行-立即贴现
					if (row.bankCode == "MYBANK") {
						// 二维码
						this.$refs.qrcode && (this.$refs.qrcode.innerHTML = ""); // 清除之前定义的二维码

						this.qrCode = new qrCode("qrcode", {
							width: 200,
							height: 200,
							text: row.mybankDiscountUrl
								.replace(/&amp;/g, "&")
								.replace("http://localhost", "https://xbc.rzline.com.cn"),
						});

						// 打开弹框
						// window.open('https://e.mybank.cn/ssomode/gateway/welcome.htm?sceneKey=CROSS_ECT_BILL&bizFrom=douban', '_blank');
						this.code2Param.networkModel = true;

						return false;
					}

					if (row.discountChannel == "jd") {
						this.allParam.discountData = row; // 选择贴入行的数据
						console.log(
							this.allParam.discountData,
							"discountData",
							this.$store.state.user.userInfo.balance,
							"balance"
						);
						// this.allParam.discountData.discountSyncOrderJdDto.orderStatus === '40'
						this.addLoading();

						let params = {
							syncOrderId: this.allParam.discountData.id,
						};

						this.sendPut({
							url: `/web/discount-order/select-discount-bank/${
								this.allParam.discountData.discountOrderId
							}`,
							data: params,
							successCallback: (result) => {
								this.allParam.servicePrice = Number(
									this.$store.state.user.userInfo.balance
								).sub(this.allParam.discountData.serviceCharge);

								this.code = 3; // 步骤
								this.current = 2; // 步骤
								// 更改用户数据
								this.allParam.discountData =
									result.data.data.discountSyncOrderDto;
								// this.handleCode4Param(); // code4数据&步骤
							},
						});

						return false;
					}

					// 其他银行-立即贴现
					// 存在账户-存在已签约成功的账户
					if (row.status == 10) {
						// 如果是平安银行则给用户提示
						if (row.bankCode === "PINGAN") {
							this.showTip({
								tipMessage:
									"<div class='fb f16'>贴现至平安银行后需准备该笔贴现资金去向的合同发票及流水，<br />以备银行后续查验</div>", // 提示信息
								tipLogo: "tip_prompt", // 提示logo
								tipButtonLeft: "我知道了", // 左按钮名称
								tipButtonLeftType: "default", // 左按钮的类型
								tipButtonLeftCall: function() {
									_this.hidePopus();
								}, // 左按钮回调
								title: "温馨提示", // 顶部title
							});
						}

						// 如果是华润银行则给用户提示
						// if (row.bankCode === 'HUARUN') {
						//   this.showTip({
						//     tipMessage: "<div class='fb f16'>【华润银行】贴现请联系客户经理进行操作！</div>", // 提示信息
						//     tipLogo: "tip_prompt", // 提示logo
						//     tipButtonLeft: "我知道了", // 左按钮名称
						//     tipButtonLeftType: "default", // 左按钮的类型
						//     tipButtonLeftCall: function () {
						//       _this.hidePopus();
						//     }, // 左按钮回调
						//     title: "温馨提示", // 顶部title
						//   });
						//   return
						// }

						this.allParam.discountData = row; // 选择贴入行的数据
						console.log(
							this.allParam.discountData,
							"discountData",
							this.$store.state.user.userInfo.balance,
							"balance"
						);
						this.allParam.servicePrice = Number(
							this.$store.state.user.userInfo.balance
						).sub(this.allParam.discountData.serviceCharge); // 服务费余额-服务费

						this.code = 3; // 步骤
						this.current = 2; // 步骤

						this.sendGet({
							url: "/trade-center/discount-acct/bank/credit-channel/operation",
							data: {
								discountChannelCode: row.discountChannel,
								bankCode: row.bankCode,
								operationCode: "DISCOUNT_INVOICE_UPLOAD",
							},
							successCallback: (result) => {
								// 查询到是否需要上传资料里 威海蓝海特殊处理 走单独的上传页面
								this.isInvoiceUploaded =
									result.data.data &&
									!["WHLH", "fumin"].includes(
										this.allParam.discountData.discountChannel
									);
								// this.allParam.discountData.discountChannel !== "WHLH";
								console.log(
									"查询是否需要上传合同***",
									result.data.data,
									["WHLH", "fumin"].includes(
										this.allParam.discountData.discountChannel
									)
								);
							},
						});
						return false;
					}

					// true 存在账户-没有签约成功账户，提示进行签约;
					// false 不存在账户，提示进行开户
					this.code1Param.acctNormal.length > 0
						? _this.handleAcctTip_qy()
						: this.handleAcctTip_kh();
					break;

				case 3:
					// 威海蓝海 跳过额度查询 上传贸易背景资料
					// if (this.allParam.discountData.discountChannel === "WHLH") {
					if (
						["WHLH", "fumin"].includes(
							this.allParam.discountData.discountChannel
						)
					) {
						this.whlhselfCode = 1;
						this.code = 8;
						this.initdata();
					} else if (
						this.allParam.discountData.discountSyncOrderJdDto &&
						["10", "20", "40", "21"].includes(
							this.allParam.discountData.discountSyncOrderJdDto.orderStatus
						)
					) {
						this.checkOrderInfo();
					} else {
						// 用户下单
						this.addLoading();

						let params = {
							syncOrderId: this.allParam.discountData.id,
						};

						if (this.isInvoiceUploaded) {
							let arr = this.discountRequirement.invoice
								.filter((item) => item.fileUrl)
								.map((item) => item.fileUrl, []);
							params = Object.assign({}, params, {
								contractFile: this.discountRequirement.contract.fileUrl,
								invoiceFile: arr.join(","),
							});
						}

						this.sendPut({
							url: `/web/discount-order/select-discount-bank/${
								this.allParam.discountData.discountOrderId
							}`,
							data: params,
							successCallback: (result) => {
								// 更改用户数据
								this.allParam.discountData =
									result.data.data.discountSyncOrderDto;
								this.handleCode4Param(); // code4数据&步骤
							},
						});
					}

					break;

				case 4:
					if (this.allParam.discountData.bankCode === "HUARUN") {
						this.sendPut({
							url: `/web/discount-order/customerConfirmOrder/${
								this.allParam.discountData.discountOrderId
							}`,
							data: "",
							successCallback: (result) => {
								// 更改用户数据
								// this.allParam.discountData = result.data.data.discountSyncOrderDto;
								this.sendGet(
									{
										url: `/web/discount-order/getHuarunQrCode/`,
									},
									(result) => {
										console.log("ack回调", result);
										if (result.data) {
											this.showHuarunBankSign.HuarunQrCode = result.data.data;
											this.code = 6;
											this.current = 4;
										}
									},
									(result) => {
										// console.log("其他回调", result);
									}
								);
							},
						});
					} else {
						this.checkOrderInfo();
					}

					break;
				case 8:
					// 上一手贸易信息进行额度查询
					// if (this.allParam.discountData.discountChannel === 'fumin') {
					if (this.allParam.discountData.discountChannel === "fumin") {
						this.code = 14;
					} else {
						this.code = 10;
					}
					break;
				case 10:
					// 上传贸易背景资料
					this.code = 10;
					let params = {
						syncOrderId: this.allParam.discountData.id,
					};

					let arr = this.discountRequirement.invoice
						.filter((item) => item.fileUrl)
						.map((item) => item.fileUrl, []);
					params = Object.assign({}, params, {
						contractFile: this.discountRequirement.contract.fileUrl,
						invoiceFile: arr.join(","),
						invoiceTemplateFile: this.discountRequirement.invoiceTemplateFile
							.fileUrl,
					});

					if (
						params.contractFile ||
						params.invoiceFile ||
						params.invoiceTemplateFile
					) {
						this.addLoading();
						this.sendPut({
							url: `/web/discount-order/select-discount-bank/${
								this.allParam.discountData.discountOrderId
							}`,
							data: params,
							successCallback: (result) => {
								// 更改用户数据
								this.allParam.discountData =
									result.data.data.discountSyncOrderDto;
								this.code = 12;
								this.initdata();
								this.syncWhlh();
							},
						});
					} else {
						this.$Message.warning("请上传贸易背景资料！");
					}
					break;
				case 9:
					if (this.allParam.discountData.discountChannel === "WHLH") {
						// 查询蓝海额度
						// 判断额度是否充足
						let amountLimitFlag =
							this.examineDtoAmount.amountLimit >
							this.examineDtoAmount.billAmount;
						let dtoAmountFlag =
							this.examineDtoAmount.contractAmountLimit +
								this.examineDtoAmount.invoiceAmountLimit >
							this.examineDtoAmount.billAmount;
						if (amountLimitFlag && dtoAmountFlag) {
							let params = {
								syncOrderId: this.allParam.discountData.id,
								frontCertName: this.frontCertName,
							};
							if (this.frontCertName) {
								Object.assign(params, {
									frontCertName: this.frontCertName,
								});
							}

							this.sendPut({
								url: `/web/discount-order/select-discount-bank/${
									this.allParam.discountData.discountOrderId
								}`,
								data: params,
								successCallback: async (result) => {
									// 更改用户数据
									this.allParam.discountData = await result.data.data
										.discountSyncOrderDto;
									this.frontCertName = "";
									this.showDtoBtn();
									this.code = 4;
									this.handleCode4Param(); // code4数据&步骤
								},
							});
						} else {
							this.code = 10;
							this.initdata();
						}
					} else if (this.allParam.discountData.discountChannel === "fumin") {
						let amountLimitFlag =
							this.examineDtoAmount.amountLimit >
							this.examineDtoAmount.billAmount;
						if (amountLimitFlag) {
							let params = {
								syncOrderId: this.allParam.discountData.id,
								frontCertName: this.frontCertName,
							};
							if (this.frontCertName) {
								Object.assign(params, {
									frontCertName: this.frontCertName,
								});
							}

							this.sendPut({
								url: `/web/discount-order/select-discount-bank/${
									this.allParam.discountData.discountOrderId
								}`,
								data: params,
								successCallback: async (result) => {
									// 更改用户数据
									this.allParam.discountData = await result.data.data
										.discountSyncOrderDto;
									this.frontCertName = "";
									this.showDtoBtn();
									this.code = 4;
									this.handleCode4Param(); // code4数据&步骤
								},
							});
						} else {
							this.code = 14;
							this.initdata();
						}
					}

					break;
				case 13:
					// 查询合同发票审核状态
					this.getWhlhDocStatus();
					if (this.examineDocStatus == "SUCCESS") {
						this.frontCertName = "";
						this.showDtoBtn();
						this.code = 4;
						this.handleCode4Param(); // code4数据&步骤
					} else {
						// 重新提交
						this.discountRequirement.invoice = [
							{
								filename: "",
								fileUrl: "",
								pactAmount: "",
								buyCompanyName: "",
								loading: false,
							},
						];
						this.discountRequirement.contract.fileUrl = "";
						if (this.allParam.discountData.discountChannel === "WHLH") {
							this.code = 10;
						} else if (this.allParam.discountData.discountChannel === "fumin") {
							// 重新提交
							this.code = 14;
						}
					}
					break;
				case 14:
					console.log(this.discountRequirement);
					// 上传贸易背景资料
					this.code = 14;
					let reqParams = {
						syncOrderId: this.allParam.discountData.id,
					};
					let contractFile = {
						pactAmount: this.discountRequirement.contract.pactAmount,
						buyCompanyName: this.discountRequirement.contract.pactAmount,
						fileType: "CONTRACT",
						ossUrl: this.discountRequirement.contract.fileUrl,
					};
					let invoice = [];

					let invoiceList = this.discountRequirement.invoice
						.filter(
							(item) => item.fileUrl && item.pactAmount && item.buyCompanyName
						)
						.map((item) => {
							invoice.push({
								pactAmount: item.pactAmount,
								buyCompanyName: item.buyCompanyName,
								fileType: "INVOICE",
								ossUrl: item.fileUrl,
							});
							return item.fileUrl;
						}, []);
					reqParams = Object.assign({}, reqParams, {
						contractFile: this.discountRequirement.contract.fileUrl,
						invoiceFile: invoiceList.join(","),
						discountOrderFileList: [contractFile, ...invoice],
					});

					if (
						reqParams.contractFile ||
						reqParams.invoiceFile 
					) {
						this.addLoading();
						this.sendPut({
							url: `/web/discount-order/select-discount-bank/${
								this.allParam.discountData.discountOrderId
							}`,
							data: reqParams,
							successCallback: (result) => {
								console.log(result);
								// 更改用户数据
								this.allParam.discountData =
									result.data.data.discountSyncOrderDto;
								this.code = 12;
								this.initdata();
								this.syncFM();
							},
						});
					} else {
						this.$Message.warning("请上传贸易背景资料及金额和公司名称！");
					}
					break;
				case 15:
					// 富民 查询合同发票审核状态
					this.getFMDocStatus();

					if (this.examineDocStatus == "SUCCESS") {
						this.frontCertName = "";
						// this.showDtoBtn();
						this.code = 9;
						// this.handleCode4Param(); // code4数据&步骤
					} else {
						// 重新提交
						this.discountRequirement.invoice = [
							{
								filename: "",
								fileUrl: "",
								pactAmount: "",
								buyCompanyName: "",
								loading: false,
							},
						];
						this.discountRequirement.contract.fileUrl = "";
						// 重新提交
						this.code = 14;
					}
					break;
			}
		},
		// 蓝海额度不足 合同审核
		whlhDtoExamined() {
			this.code = 12;
			if (this.allParam.discountData.discountChannel === "fumin") {
				this.syncFM();
			} else if (this.allParam.discountData.discountChannel === "WHLH") {
				this.syncWhlh();
			}
		},
		// 重新查询额度
		queryAgain() {
			this.code = 8;
			this.frontCertName = "";
		},
		// 同步威海蓝海 合同发票审核状态
		syncWhlh() {
			this.addLoading();
			this.sendGet({
				url: `/web/discount-order/updateWhlhInvoiceLimit/${
					this.allParam.discountData.discountSyncOrderWhlhDto.syncOrderId
				}`,
				successCallback: (result) => {
					// 更新订单详情
					this.code = 13;
					_this.$set(
						_this.allParam.discountData,
						"discountSyncOrderDto",
						result.data.data
					);
					_this.$forceUpdate();
					// 更新审核状态
					this.getWhlhDocStatus();
				},
			});
		},
		// 同步威海蓝海 合同发票审核状态
		syncFM() {
			this.addLoading();
			this.sendGet({
				url: `/web/discount-order/fuminOrderApplyResult/${
					this.allParam.discountData.id
				}`,
				successCallback: (result) => {
					// 更新订单详情
					this.code = 15;
					_this.$set(
						_this.allParam.discountData,
						"discountSyncOrderDto",
						result.data.data
					);
					_this.$forceUpdate();
					// 更新审核状态
					this.getFMDocStatus();
				},
			});
		},
		// 根据前手资料查询额度(区分渠道：蓝海、富民)
		queryAmountLimit() {
			if (this.frontCertName) {
				this.addLoading();
				console.log(this.allParam.discountData);
				let params = { blicNo: "", frontCertName: this.frontCertName };
				let discountChannel = this.allParam.discountData.discountChannel;
				switch (discountChannel) {
					case "WHLH":
						params.blicNo = this.allParam.discountData.discountSyncOrderWhlhDto.certNo;
						break;
					case "fumin":
						params.blicNo = this.allParam.discountData.discountSyncOrderFuminDto.certNo;
						break;
				}
				try {
					this.queryDtoAmount(discountChannel, params)
						.then((res) => {
							console.log(res);
							if (discountChannel === "WHLH") {
								switch (res.state) {
									case "000001":
										Object.assign(this.examineDtoAmount, res);
										this.$Message.success("查询成功！");
										this.code = 9;
										break;
									case "000002":
										this.$Message.warning("额度状态拒绝！");
										break;
									case "000003":
										this.$Message.warning("额度状态暂停！");
										break;
									case "000004":
										this.$Message.warning("额度审核中！");
										break;
								}
							} else if (discountChannel === "fumin") {
								if (res) {
									this.$Message.success("查询成功！");
									this.code = 9;
									_this.examineDtoAmount.amountLimit = res.amountList?res.amountList.reduce(
										(accum, current) =>
											Number(accum) + Number(current.contractAveAmt),
										0
									):0;
								} 
							}
						})
						.catch((err) => {
							console.log(err);
						});
				} finally {
				}
			} else {
				this.$Message.warning("请输入上一手贸易公司名称！");
			}
		},
		// 判断蓝海合同发票审核状态
		getWhlhDocStatus() {
			let contractStatus = "";
			let ivoiceStatus = "";
			let status = "";
			console.log(
				"getWhlhDocStatus--",
				this.allParam.discountData.discountSyncOrderDto.discountSyncOrderWhlhDto
			);
			let discountSyncOrderWhlhDto = this.allParam.discountData
				.discountSyncOrderDto.discountSyncOrderWhlhDto;
			if (discountSyncOrderWhlhDto.contractNo) {
				if (discountSyncOrderWhlhDto.contractAuditStatus == "000000") {
					contractStatus = "SUCCESS";
				} else if (discountSyncOrderWhlhDto.contractAuditStatus == "000001") {
					contractStatus = "FAIL";
				} else {
					contractStatus = "AUDIT";
				}
			}

			if (discountSyncOrderWhlhDto.invoiceNo) {
				if (discountSyncOrderWhlhDto.invoiceAuditStatus == "000000") {
					ivoiceStatus = "SUCCESS";
				} else if (discountSyncOrderWhlhDto.invoiceAuditStatus == "000001") {
					ivoiceStatus = "FAIL";
				} else {
					contractStatus = "AUDIT";
				}
			}

			if (contractStatus == "SUCCESS" || ivoiceStatus == "SUCCESS") {
				status = "SUCCESS";
			} else if (contractStatus == "FAIL" || ivoiceStatus == "FAIL") {
				status = "FAIL";
			} else {
				status = "AUDIT";
			}
			console.log("getWhlhDocStatus", status, discountSyncOrderWhlhDto);
			this.examineDocStatus = status;
			//
			if (status === "SUCCESS") {
				let discountSyncOrderWhlhDto = this.allParam.discountData
					.discountSyncOrderDto.discountSyncOrderWhlhDto;

				let params = {
					blicNo: discountSyncOrderWhlhDto.certNo,
				};
				// 查询蓝海额度
				this.queryDtoAmount(
					this.allParam.discountData.discountChannel,
					params
				).then(() => {
					this.examineDtoAmount.contractAmountLimit =
						discountSyncOrderWhlhDto.contractAmountLimit;
					this.examineDtoAmount.invoiceAmountLimit =
						discountSyncOrderWhlhDto.invoiceAmountLimit;
				});
			}
		},
		// 判断蓝海合同发票审核状态
		getFMDocStatus() {
			let discountSyncOrderFuminDto = this.allParam.discountData
				.discountSyncOrderDto.discountSyncOrderFuminDto;

			if (discountSyncOrderFuminDto) {
				switch (discountSyncOrderFuminDto.auditStatus) {
					case "01":
						this.examineDocStatus = "WAIT";
						break;
					case "02":
						this.examineDocStatus = "SUCCESS";
						break;
					case "03":
						this.examineDocStatus = "FAIL";
						break;
				}
			}
			//审核成功的话去查询额度
			if (this.examineDocStatus === "SUCCESS") {
				let discountSyncOrderFuminDto = this.allParam.discountData
					.discountSyncOrderDto.discountSyncOrderFuminDto;

				let params = {
					blicNo: discountSyncOrderFuminDto.certNo,
				};
				// 查询蓝海额度
				this.queryDtoAmount(
					this.allParam.discountData.discountChannel,
					params
				).then((res) => {
					_this.examineDtoAmount.amountLimit = res.amountList.reduce(
						(accum, current) => Number(accum) + Number(current.contractAveAmt),
						0
					);
				});
			}
		},
		//  合同审核按钮 (根据渠道：蓝海、富民 额度是否充足展示)
		showDtoBtn() {
			if (this.allParam.discountData.discountSyncOrderDto) {
				if (this.allParam.discountData.discountChannel === "WHLH") {
					let Dto = this.allParam.discountData.discountSyncOrderDto
						.discountSyncOrderWhlhDto;
					let invoiceAmountLimit = Dto.invoiceAmountLimit || 0;
					let contractAmountLimit = Dto.contractAmountLimit || 0;
					this.isShowWhlhDtoBtn =
						Dto.queryLimitType === "UPLOAD" &&
						invoiceAmountLimit + contractAmountLimit <
							this.allParam.discountData.discountSyncOrderDto.billAmount;
				} else if (this.allParam.discountData.discountChannel === "fumin") {
					let Dto = this.allParam.discountData.discountSyncOrderDto
						.discountSyncOrderFuminDto;
					let amountLimit = _this.examineDtoAmount.amountLimit || 0;
					this.isShowWhlhDtoBtn =
						Dto.queryLimitType === "UPLOAD" &&
						amountLimit <
							this.allParam.discountData.discountSyncOrderDto.billAmount;
				}
			}
		},

		/** 银行额度查询
		 * discountChannel：渠道额度查询地址
		 * params： 额度查询参数
		 * **/

		queryDtoAmount(discountChannel, params) {
			let url = "";
			switch (discountChannel) {
				case "WHLH":
					url = "/web/whlh-discount/debtStatus";
					break;
				case "fumin":
					url = "/web/fumin-op-discount/corp-quota";
					break;
			}
			return new Promise((reolve, reject) => {
				this.sendGet({
					url: url,
					data: params,
					successCallback: (result) => {
						if (result.data.code === "ACK") {
							if (discountChannel === "fumin") {
								this.examineDtoAmount.billAmount = this.allParam.discountData.billAmount;
								reolve(result.data.data);
							} else {
								Object.assign(this.examineDtoAmount, result.data.data);
								this.examineDtoAmount.billAmount = this.allParam.discountData.billAmount;
								reolve(result.data.data);
							}
						} else {
							this.$Message.warning(result.data.message);
						}
						console.log("this.allParam.discountData---", result);
						this.removeLoading();
					},
					errCallback: (error) => {
						reject(error);
						this.removeLoading();
					},
				});
			});
		},

		// 蓝海资料审核成功后查询贸易总额度
		findTotalAmount() {
			this.whlhselfCode = 1;
			this.code = 8;
			this.initdata();
		},
		// 初始化参数
		initdata() {
			this.frontCertName = "";
			this.invoiceType = "01";
			this.discountRequirement.invoice = [
				{
					filename: "",
					fileUrl: "",
					pactAmount: "",
					buyCompanyName: "",
					loading: false,
				},
			];
			this.discountRequirement.contract.fileUrl = "";
			this.discountRequirement.contract.pactAmount = "";
			this.discountRequirement.contract.buyCompanyName = "";
			this.discountRequirement.invoiceTemplateFile.fileUrl = "";
			this.discountRequirement.invoiceTemplateFile.filename = "";
		},

		// 上一步按钮
		preBtnEvent() {
			if (this.code == 3 || this.code == 8 || this.code == 10) {
				this.code = 2;
			}
			if (this.code == 5 || _this.code == 7) {
				this.handleCode4Param(); // code4数据&步骤
			}
		},
		// 华润 未签约 小程序引导页下一步
		HuaRunNextTick() {
			if (this.showHuarunBankSign.code < 7) {
				if (this.showHuarunBankSign.code === 5) {
					this.sendPost(
						{
							url: "/trade-center/discount-acct-bank/applyEntering",
							data: {
								acct: {
									id: this.allParam.discountAcctDto.id,
								},
								channelCode: "HUARUN",
							},
						},
						(result) => {
							console.log("------", result);
							this.showHuarunBankSign.code++;

							this.showHuarunBankSign.stepArr.map((item, index) => {
								if (index < this.showHuarunBankSign.code - 1) {
									item.active = true;
								} else {
									item.active = false;
								}
							});
							this.syncSignBankStatus();
						},
						(result) => {
							if (result.data.message === "已存在相同签约渠道记录") {
								this.showHuarunBankSign.code++;

								this.showHuarunBankSign.stepArr.map((item, index) => {
									if (index < this.showHuarunBankSign.code - 1) {
										item.active = true;
									} else {
										item.active = false;
									}
								});
							}
							console.log("其他回调", result);
						}
					);
				} else {
					this.showHuarunBankSign.code++;
					this.showHuarunBankSign.stepArr.map((item, index) => {
						if (index < this.showHuarunBankSign.code - 1) {
							item.active = true;
						} else {
							item.active = false;
						}
					});
				}
			}
		},
		// 华润 未签约 小程序引导页上一步
		HuaRunPreBtenEvent() {
			if (this.showHuarunBankSign.code > 1) {
				this.showHuarunBankSign.code--;
				this.showHuarunBankSign.stepArr.map((item, index) => {
					if (index < this.showHuarunBankSign.code - 1) {
						item.active = true;
					} else {
						item.active = false;
					}
				});
				console.log(this.showHuarunBankSign);
			}
		},

		// 重新上传票面 || 回到第一步 || 返回按钮 || 取消贴现按钮
		reUpload() {
			this.handleBill(); // 票据信息清空
			this.allParam.billFile = "";
			this.allParam.billFileEtag = "";
			this.allParam.billBase64 = "";
			this.code1Param.msgTip = ""; //初始化提示
			this.code = 1;
			this.current = 0;
			this.isHUARUNFinsh = false;

			this.billSubNo1 = "";
			this.billSubNo2 = "";
			this.allParam.billSubNo = null;
			this.billSubStatus = false;
			// this.frontCertName = "";
			this.examineDocStatus = "";
			this.isShowWhlhDtoBtn = false;
			// this.discountRequirement.invoice = [
			// 	{ filename: "", fileUrl: "", loading: false },
			// ];
			// this.discountRequirement.contract.fileUrl = "";
			// this.discountRequirement.invoiceTemplateFile.fileUrl = "";
			// this.discountRequirement.invoiceTemplateFile.filename = "";
			this.initdata();
		},

		//======== 步骤 1 start ===========//
		// 判断tab是否可选择
		// handleTabTrue: function () {
		//   this.isTabTrue = !this.fungetLogin() ? false : true;
		// },

		// tab点击时触发
		initTip() {
			this.allParam.billNoTip = false;
			this.allParam.acceptorBankNumTip = false;
		},

		// 京东上传贸易背景资料
		JDInvoiceUploaded() {
			// const { href } =
			// const { href } = this.$router.resolve({
			// 	name: "jdJumpPage",
			// 	params: {
			// 		platformUserId:
			// 			_this.allParam.discountData.discountSyncOrderJdDto.platformUserId,
			// 		bankCode: _this.allParam.discountData.bankCode,
			// 		endorseTradeNo:
			// 			_this.allParam.discountData.discountSyncOrderJdDto.orderNo,
			// 	},
			// });
			// console.log(href);
			// window.open(href, "_blank");
			this.sendGet({
				url:
					"/web/jd/get-sign-verify/" +
					_this.allParam.discountData.discountSyncOrderJdDto.platformUserId,
				data: { jumpPageIp: window.location.origin },
				async successCallback(result) {
					console.log(
						"signData",
						result,
						process.env.EVN_CONFIG,
						_this.rzlineUrl()
					);

					if (process.env.EVN_CONFIG !== "prod") {
						// 修改环境
						window.jpmt.env = "development";
						// 修改domain 只在测试环境或者开发环境使用，生产默认https://piaoju.jd.com
						//  window.jpmt.getDomain = () => 'https://piaoju-test.jd.com';
					}
					_this.JDModal = true;

					const creditUrl = await window.jpmt.computePageUrl({
						name: "place-an-order-mt",
						loginUrl: result.data.data.jumpPageIp + "/ApplicationDiscount",
						querys: {
							bankCode: _this.allParam.discountData.bankCode,
							endorseTradeNo:
								_this.allParam.discountData.discountSyncOrderJdDto.orderNo,
						},
						platformId: result.data.data.platformId,
						platformUserId: result.data.data.platformUserId,
						signature: result.data.data.signature,
						timestamp: result.data.data.timestamp,
						saltStr: result.data.data.saltStr,
						// ...其它参数不能少
					});
					console.log("creditUrl----", creditUrl);
					_this.JDUploadUrl = creditUrl;
					// window.open(creditUrl);
				},
			});
		},

		// 引入jd-sdk
		importJdSDK() {
			const js = document.createElement("script");
			js.src = "https://static-ftcms.jd.com/p/files/sdk-1.0.0.js?t=random";
			document.body.appendChild(js);
		},

		// JD确认弹窗同步订单
		JDModalVisbleChange() {
			this.checkOrderInfo();
		},

		// 查看示例图 && 大图
		viewerExampleShow(name) {
			const viewerData = {};

			viewerData["viewer" + name] = new Viewer(document.getElementById(name), {
				title: false, // 显示图片标题
				tooltip: false, // 显示缩放比例
				hidden: function() {
					viewerData["viewer" + name].destroy();
				},
			});

			this.$refs[name].click();
		},

		// 图片处理
		// 上传票面
		uploadImg(name) {
			// this.$refs[name].dispatchEvent(new MouseEvent('click')); // IE中有兼容性问题
			this.$refs.upload_file.click();
		},

		// 处理图片
		getFile(e, param) {
			this.imgToBase64(e, function(base, fileTarget) {
				// console.log(base, "base");
				_this.allParam.billBase64 = base;

				_this.allParam.billNoTip = false;
				_this.allParam.acceptorBankNumTip = false;

				// oss上传
				_this.ossUpload(fileTarget, (data) => {
					_this.allParam.billFile = data.url;
					console.log(data);
					_this.allParam.billFileEtag = data.res.headers.etag;
					_this.ocrDiscern(); // 进行OCR识别

					_this.allParam.ocrTimer ? clearTimeout(_this.allParam.ocrTimer) : "";
					_this.allParam.ocrTimer = setTimeout(function() {
						_this.handleBill(); // 票据信息清空
						_this.code1Param.ocrLoading = false;
						_this.code1Param.msgTip =
							"未识别到任何承兑汇票信息，请重新上传票面或手动填写";
						_this.code1Param.msgTipCss = "dp-c-fail";
					}, 40000);
				});
			});
		},

		// 进行OCR识别
		ocrDiscern() {
			// this.addLoading();
			this.code1Param.ocrLoading = true;
			this.code1Param.nextStatus = false; // 下一步标识关闭

			this.sendOther({
				url: "/web/bill/ocrRecognize",
				data: {
					imgUrl: _this.allParam.billFile,
					ossEtag: _this.allParam.billFileEtag,
				},
				tip: false,
				successCallback: (result) => {
					console.log("ack回调", result);
					if (this.code1Param.ocrLoading) {
						_this.allParam.ocrTimer
							? clearTimeout(_this.allParam.ocrTimer)
							: "";
						this.code1Param.ocrLoading = false;

						const successData = result.data.data;
						if (successData) {
							Object.assign(_this.allParam, {
								billNo: successData.acceptDraftId || "", // 票据号码
								billAmount: successData.parMoney || "", // 票面金额
								acceptorBankName: successData.acceptorBank || "", // 承兑人开户行名称
								acceptorBankNum: successData.acceptorBankNum || "", // 承兑行行号
								dueDays: successData.maturityDate || "", // 到期天数
								dueDate: successData.draftDueDate || "",
								billAmountSupper: successData.parMoney
									? _this.digitUppercase(successData.parMoney)
									: "", //大写票面金额
							});
							// 子票区间处理
							if (successData.billSubNo) {
								Object.assign(_this.allParam, {
									billSubNo: successData.billSubNo || "", // 票据号码
								});
								// let billSubNo = successData.billSubNo.split("-");
								let billSubNo = successData.billSubNo.split(/[\,\-]/); // 以非数字的字符分割
								this.billSubStatus = true;
								this.billSubNo1 = billSubNo[0];
								this.billSubNo2 = billSubNo[1];
							} else {
								Object.assign(_this.allParam, {
									billSubNo: "", // 票据号码
								});
								this.billSubStatus = false;
								this.billSubNo1 = "";
								this.billSubNo2 = "";
							}
						}

						if (result.data.message) {
							this.$Message.warning(result.data.message);
							this.code1Param.msgTip =
								"承兑汇票信息识别成功，如有错误请手动修改";
							this.code1Param.msgTipCss = "dp-c-success";
						}
					}
				},
				errCallback: (result) => {
					this.ocrDiscernFail();
				},
				failCallback: (result) => {
					this.ocrDiscernFail();
				},
			});
		},
		// ocr识别失败
		ocrDiscernFail() {
			if (_this.code1Param.ocrLoading) {
				this.handleBill(); // 票据信息清空
				this.code1Param.ocrLoading = false;
				this.code1Param.msgTip =
					"未识别到任何承兑汇票信息，请重新上传票面或手动填写";
				this.code1Param.msgTipCss = "dp-c-fail";
			}
		},
		imgUploadClick(e, type, index) {
			switch (type) {
				case "agreement":
					this.$refs[e].reUpload();
					break;
				case "img":
					this.$refs[e][0].reUpload();
					this.imgIndex = index;
					break;
				case "other":
					this.$refs[e].reUpload();
					break;
			}

			if (index) {
				this.imgIndex = index;
			}

			console.log(e, index, this.imgIndex);
		},
		// 合同上传
		agreementUploadChange(name, url, e) {
			console.log(name, url, e);
			if (url) {
				this.$set(this.discountRequirement.contract, "filename", name);
				this.$set(this.discountRequirement.contract, "fileUrl", url);
			} else {
				this.$set(this.discountRequirement.contract, "filename", e);
				this.$set(this.discountRequirement.contract, "fileUrl", name.url);
			}
		},
		// 多张发票上传
		invoiceUploadChange(name, url, e) {
			console.log(name, url, e);
			if (url) {
				this.$set(
					this.discountRequirement.invoiceTemplateFile,
					"filename",
					name
				);
				this.$set(this.discountRequirement.invoiceTemplateFile, "fileUrl", url);
			} else {
				this.$set(this.discountRequirement.invoiceTemplateFile, "filename", e);
				this.$set(
					this.discountRequirement.invoiceTemplateFile,
					"fileUrl",
					name.url
				);
			}

			if (this.discountRequirement.invoice[0].fileUrl) {
				this.discountRequirement.invoice[0].fileUrl = "";
				this.discountRequirement.invoice[0].filename = "";
				// this.$Message.warning("单张和多张发票上传方式只能选择一种");
			}
		},
		// 图片上传
		imgUploadChange(emeit, e) {
			console.log(emeit, e);
			if (e) {
				this.$set(
					this.discountRequirement.invoice[this.imgIndex],
					"fileUrl",
					e
				);
				this.$set(
					this.discountRequirement.invoice[this.imgIndex],
					"filename",
					emeit
				);
			} else {
				this.$set(
					this.discountRequirement.invoice[this.imgIndex],
					"fileUrl",
					emeit.url
				);
			}
			if (
				this.allParam.discountData.discountChannel === "WHLH" &&
				this.discountRequirement.invoiceTemplateFile.fileUrl
			) {
				this.discountRequirement.invoiceTemplateFile.fileUrl = "";
				this.discountRequirement.invoiceTemplateFile.filename = "";
				this.$Message.warning("单张和多张发票上传方式只能选择一种");
			}
		},
		invoiceAdd() {
			if (this.allParam.discountData.discountChannel === "fumin") {
				this.discountRequirement.invoice.push({
					filename: "",
					file: "",
					pactAmount: "",
					buyCompanyName: "",
					loading: false,
				});
			} else {
				this.discountRequirement.invoice.push({
					filename: "",
					file: "",
					loading: false,
				});
			}
		},
		// invoiceAdd
		invoiceDel(index) {
			this.discountRequirement.invoice[index].fileUrl = "";
			this.discountRequirement.invoice[index].filename = "";
			if (this.discountRequirement.invoice.length > 1) {
				this.discountRequirement.invoice.splice(index, 1);
			}
		},

		// 根据到期日查询计息天数
		queryDayByDate: function(data) {
			this.allParam.dueDays = "";
			this.allParam.dueDate = new Date(this.compatibilityIEDate(data)).pattern(
				"yyyy-MM-dd"
			);

			this.sendGet({
				url: "/web/bill/getDueDays",
				data: { dueDate: this.allParam.dueDate },
				tip: false, // false-显示loading, true-隐藏loading
				successCallback(result) {
					_this.allParam.dueDays = result.data.data;
				},
			});
		},

		// 票号 blur
		blurNoNum() {
			console.log(this.allParam.billNo, "this.allParam.billNoNumber");
			if (_this.allParam.billNo.length != 30) {
				_this.allParam.billNoTip = true;
			} else {
				_this.allParam.billNoTip = false;
			}
		},

		// 承兑行 blur
		blurBank: function() {
			if (this.allParam.acceptorBankNum.length != 12) {
				_this.allParam.acceptorBankNumTip = true;
				return false;
			}
			_this.allParam.acceptorBankNumTip = false;

			this.sendGet(
				{
					url: "/web/bill/getAcceptorBankName",
					data: { acceptorBankNum: this.allParam.acceptorBankNum },
					tip: false, // false-显示loading, true-隐藏loading
				},
				(result) => {
					this.allParam.acceptorBankName = result.data.data;
				}
			);
		},

		// 下一步，获取银行报价-选择账户
		// 存在账户-没有签约成功账户，提示进行签约
		handleAcctTip_qy(isTrue) {
			this.showTip({
				tipMessage:
					"<div class='fb '>您还未与银行进行签约，无法发起贴现<br/>是否立即前往签约？</div>", // 提示信息
				tipLogo: "tip_prompt", // 提示logo
				tipButtonLeft: "暂不签约", // 左按钮名称
				tipButtonLeftType: "default", // 左按钮的类型
				tipButtonRight: "立即签约", // 右按钮名称
				tipButtonRightType: "primary", // 右按钮类型
				tipButtonLeftCall: function() {
					_this.hidePopus();

					isTrue ? _this.queryBankRate() : ""; // 获取银行报价
				}, // 左按钮回调
				tipButtonRightCall: function() {
					_this.hidePopus();
					_this.$router.push("/SilverTicketManage");
				}, // 右按钮回调
				title: "提示", // 顶部title
			});
		},

		// 不存在账户-提示开户
		handleAcctTip_kh(isTrue) {
			this.showTip({
				tipMessage:
					"<div class='fb '>您暂未开通任何线上快贴账户<br/>是否立即前往开通？</div>", // 提示信息
				tipLogo: "tip_prompt", // 提示logo
				tipButtonLeft: "暂不开通", // 左按钮名称
				tipButtonLeftType: "default", // 左按钮的类型
				tipButtonRight: "立即开通", // 右按钮名称
				tipButtonRightType: "primary", // 右按钮类型
				tipButtonLeftCall: function() {
					_this.hidePopus();
					isTrue ? _this.queryBankRate() : ""; // 获取银行报价
				}, // 左按钮回调
				tipButtonRightCall: function() {
					_this.hidePopus();
					_this.$router.push("/SilverTicketManage");
				}, // 右按钮回调
				title: "提示", // 顶部title
			});
		},

		// 获取银行报价
		queryBankRate() {
			_this.code1Param.accountModal
				? (_this.code1Param.accountModal = false)
				: ""; // 关闭账户列表弹框
			_this.code = 11; // 步骤
			_this.current = 1; // 进度条步骤

			// 文件上传
			this.queryBankRateAjax();
		},
		queryBankRateAjax() {
			this.allParam.dueDate = new Date(
				this.compatibilityIEDate(this.allParam.dueDate)
			).pattern("yyyy-MM-dd");

			if (
				this.allParam.dueDate.length > 0 &&
				this.allParam.dueDate.indexOf("-") == -1
			) {
				this.allParam.dueDate =
					this.allParam.dueDate.substring(0, 4) +
					"-" +
					this.allParam.dueDate.substring(4, 6) +
					"-" +
					this.allParam.dueDate.substring(6);
			}

			let queryDiscountRate = this.handleObj(
				[
					"userId",
					"billFile",
					"billNo",
					"billAmount",
					"acceptorBankNum",
					"dueDays",
					"dueDate",
					"acceptorBankName",
				],
				this.allParam
			);

			if (this.allParam.billSubNo) {
				queryDiscountRate.billSubNo = this.allParam.billSubNo;
			} else {
				queryDiscountRate.billSubNo = null;
			}

			queryDiscountRate.acctId = this.allParam.discountAcctDto.id || null; // 账户id
			this.code2Param.discountBankList = [];

			// this.addLoading();
			queryDiscountRate.dueDate = new Date(
				this.compatibilityIEDate(queryDiscountRate.dueDate)
			).pattern("yyyy-MM-dd");

			// 获取银行报价
			this.sendOther({
				// url: '/web/discount-order/query-discount-rate',
				url: "/web/discount-order/async-query-discount-rate",
				data: queryDiscountRate,
				tip: false,
				successCallback: (result) => {
					// console.log("ack回调", result);
					this.code2Param.discountBankList = result.data.data.bankList;
					this.code2Param.orderId = result.data.data.id;

					// 步骤2的数据
					this.code2Param.table1.data5[0] = {
						name: "票号",
						key: this.allParam.billNo,
						billAmount: this.formatMoney(this.allParam.billAmount, 2, ""),
						billAmountSupper: this.allParam.billAmountSupper,
					};

					let dueDate = this.allParam.dueDate.split("-");
					this.code2Param.table1.data5[1] = {
						name: "到期日",
						key:
							dueDate[0] +
							"年" +
							dueDate[1] +
							"月" +
							dueDate[2] +
							"日（计息" +
							_this.allParam.dueDays +
							"）", // 2019年12月12日（计息180天）
					};

					this.code2Param.table1.data5[2] = {
						name: "承兑人",
						key:
							_this.allParam.acceptorBankName || _this.allParam.acceptorBankNum,
					};

					this.code = 2; // 步骤
					this.current = 1; // 进度条步骤
					this.queryDiscountRateTime(); // 轮询查询贴现利率
				},
				errCallback: (result) => {
					// console.log("其他回调", result);
					_this.code1Param.accountModal
						? (_this.code1Param.accountModal = false)
						: ""; // 关闭账户列表弹框
					_this.code = 1; // 步骤
					_this.current = 0; // 进度条步骤
					if (result.data.data && result.data.data.errorCode) {
						switch (result.data.data.errorCode) {
							case "FUMIN_001": {
								// 富民渠道富民银行未签约
								this.showTip({
									tipMessage:
										"<div class='fb '>您上传的票面大于500万元<br/>如需贴现请签约富民银行并提交相关补充资料</div>", // 提示信息
									tipLogo: "tip_prompt", // 提示logo
									tipButtonLeft: "暂不提交", // 左按钮名称
									tipButtonLeftType: "default", // 左按钮的类型
									tipButtonRight: "立即提交资料", // 右按钮名称
									tipButtonRightType: "primary", // 右按钮类型
									tipButtonLeftCall: function() {
										_this.hidePopus();
									}, // 左按钮回调
									tipButtonRightCall: function() {
										_this.hidePopus();
										_this.$router.push("/SilverTicketManage");
									}, // 右按钮回调
									title: "提示", // 顶部title
									bottomCall: function() {
										// 客服
										_this.handleCustomerBtn();
									},
									bottom:
										'<span class="cp dl mt10 c005FFF">申请客服帮助</span>',
								});
								break;
							}
							case "FUMIN_002": {
								// 富民渠道富民银行签约极速贴
								this.showTip({
									tipMessage:
										"<div class='fb '>您上传的票面大于500万元<br/>如需贴现请提交富民银行补充资料</div>", // 提示信息
									tipLogo: "tip_prompt", // 提示logo
									tipButtonLeft: "暂不提交", // 左按钮名称
									tipButtonLeftType: "default", // 左按钮的类型
									tipButtonRight: "立即提交资料", // 右按钮名称
									tipButtonRightType: "primary", // 右按钮类型
									tipButtonLeftCall: function() {
										_this.hidePopus();
									}, // 左按钮回调
									tipButtonRightCall: function() {
										_this.hidePopus();
										_this.$router.push("/SilverTicketManage");
									}, // 右按钮回调
									title: "提示", // 顶部title
									bottomCall: function() {
										// 客服
										_this.handleCustomerBtn();
									},
									bottom:
										'<span class="cp dl mt10 c005FFF">申请客服帮助</span>',
								});
								break;
							}
							case "FUMIN_003": {
								// 富民渠道富民银行升级富企贴中
								this.showTip({
									tipMessage:
										"<div class='fb '>您上传的票面大于500万元<br/><span class='c4771FF'>您的大额贴现资质正在审核中，请耐心等待</span></div>", // 提示信息
									tipLogo: "tip_prompt", // 提示logo
									tipButtonLeft: "关闭", // 左按钮名称
									tipButtonLeftType: "default", // 左按钮的类型
									tipButtonLeftCall: function() {
										_this.hidePopus();
									}, // 左按钮回调
									title: "提示", // 顶部title
								});
								break;
							}
							default:
								this.hasOwnProperty("loading") ? (this.loading = false) : "";
								this.$Message.error(result.data.message || result.data.remark);
						}
					} else {
						this.hasOwnProperty("loading") ? (this.loading = false) : "";
						this.$Message.error(result.data.message || result.data.remark);
					}
				},
			});
		},
		// 轮询查询贴现利率
		queryDiscountRateTime() {
			this.num = 0;
			this.isQueryDiscountRateAjax();
		},
		// 判断是否需要查询贴现利率
		isQueryDiscountRateAjax() {
			let query = this.code2Param.discountBankList.filter(
				(v) => !v.isQueryRate
			);

			if (query.length > 0) {
				this.num++;

				if (this.num > 60) {
					this.code2Param.discountBankList.filter((item, index) => {
						item.isQueryRate = true;
						this.$set(this.code2Param.discountBankList, index, item);
					});

					return;
				}

				this.code === 2 && this.queryDiscountRateAjax(query);
			}
		},
		// 查询贴现利率
		queryDiscountRateAjax(query) {
			query = query.map((v) => v.bankCode);

			this.sendGet({
				url: "/web/discount-order/redis-discount-rate",
				data: {
					id: this.code2Param.orderId,
					bankCodeList: query,
					v: Date.now(),
				},
				tip: false,
				successCallback: (result) => {
					this.code2Param.discountBankList.filter((item) => {
						result.data.data.filter((v) => {
							if (v && v.bankCode === item.bankCode) {
								Object.assign(item, v, { isQueryRate: true });
							}
						});
					});

					// 可签约
					let newArr = this.code2Param.discountBankList.filter((v) =>
						this.handleDiscountStatus(v)
					);

					// 暂无授信
					let newArr1 = this.code2Param.discountBankList.filter(
						(v) => !this.handleDiscountStatus(v)
					);

					newArr.sort((a, b) => {
						const num1 = Number(a.realDiscountRate || a.activDiscountRate);
						const num2 = Number(b.realDiscountRate || b.activDiscountRate);

						if (a.bankCode === "MYBANK") {
							a.activDiscountRate = 0;
							a.realDiscountRate = 0;
						}
						if (b.bankCode === "MYBANK") {
							a.activDiscountRate = 0;
							a.realDiscountRate = 0;
						}

						if (
							!(a.realDiscountRate || a.activDiscountRate) ||
							!(b.realDiscountRate || b.activDiscountRate)
						) {
							return num2 - num1;
						} else {
							return num1 - num2;
						}
					});

					this.code2Param.discountBankList = newArr.concat(newArr1);

					console.log(this.code2Param.discountBankList, "=======");

					setTimeout(() => {
						this.isQueryDiscountRateAjax();
					}, 1000);
				},
				errCallback: (result) => {
					if (result.data.code !== "NACK") {
						this.code2Param.discountBankList = [];
						this.$Message.error(result.data.message || result.data.remark);
						this.code = 1; // 步骤
						this.current = 0; // 进度条步骤
					} else {
						setTimeout(() => {
							this.isQueryDiscountRateAjax();
						}, 1000);
					}
				},
			});
		},
		//======== 步骤 1 end ===========//

		//======== 步骤 2 start ===========//
		// 处理状态
		handleDiscountStatus(item) {
			if (item.bankCode === "MYBANK") {
				return false;
			}

			return item.rateStatus == "0" &&
				(item.status == 10 ||
					(item.status == null &&
						item.discountAcctBankStatus != "CREDIT_SUCCESS"))
				? true
				: false;
		},

		/*table合并行列的算法 计算table合并的行和列*/
		handleSpan({ row, column, rowIndex, columnIndex }) {
			if (rowIndex === 0 && columnIndex === 2) {
				return [3, 1];
			} else if (rowIndex === 1 && columnIndex === 2) {
				return [0, 0];
			} else if (rowIndex === 2 && columnIndex === 2) {
				return [0, 0];
			}
		},
		// 华润未签约 引导操作
		showHuarunBankSignClick(account) {
			console.log("-----", account);
			this.chooseAccount = account;
			this.showHuarunBankSign.stepArr.map((item, index) => {
				item.active = false;
			});
			this.showHuarunBankSign.code = 1;
			this.getHuarunQrCode();
			this.showHuarunBankSign.showType = true;
		},

		// code-4
		// 操作指南数据
		handleCode4Param() {
			this.code4Param.activeBankOpration = this.code4Param.bankOperationList[
				this.code4Param.activeBankCode
			]; // 默认选择的银行操作列表
			if (this.code4Param.bankList.length == 0) {
				let bankObj = {
					HS: "徽商银行",
					MS: "民生银行",
					NJ: "南京银行",
					NB: "宁波银行",
					XY: "兴业银行",
					ZS: "招商银行",
					PA: "平安银行",
					ZX: "中信银行",
					ZG: "中国银行",
					JT: "交通银行",
					CS: "长沙银行",
					GF: "广发银行",
					MT: "浙江民泰银行",
					TL: "浙江泰隆商业银行",
					NY: "中国农业银行",
					HZ: "杭州银行",
					NS: "乌鲁木齐农商银行",
					PF: "浦发银行",
					GS: "中国工商银行",
					JS: "中国建设银行",
					SJ: "盛京银行",
					CZ: "浙商银行",
					QX: "清徐农村商业银行",
					JH: "金华银行",
					ZY: "中原银行",
					HX: "华夏银行",
					NCSY: "重庆农村商业银行",
					CJSY: "江苏长江商业银行",
					YZ: "邮政银行",
					GD: "中国光大银行",
					ZY2: "中原银行",
					JT2: "交通银行",
				};
				for (let key in bankObj) {
					this.code4Param.bankList.push({
						bankName: bankObj[key], // 银行名称
						bankCode: key, // 银行标识
					});
				}
			}

			this.code = 4;
		},

		// 操作指南 步骤
		chooseTab: function(val, index) {
			// 重置每个银行的左边步骤放大图的索引值
			this.stepImge = 0;
			this.code4Param.activeBankCode = val;
			if (
				this.code4Param.bankOperationList[val].length == 1 ||
				this.code4Param.bankOperationList[val].length == 2
			) {
				let cuData = JSON.parse(
					JSON.stringify(this.code4Param.bankOperationList[val])
				);
				this.code4Param.bankOperationList[val].length == 1
					? (cuData[0].stepDes = "步骤")
					: "";
				cuData.unshift({
					stepDes: "网银怎么提票？",
					content:
						'由干各个银行网银情况不同，提票时一般要遵循以下原则：<br/>① 贴现方式是“买断式”；<br/>② 清算方式是“线下清算”或“非票款对付”或“线下付款”；<br/>③ 转让方式为“可转让”；<br/>④ 贴入行相关信息参照平台提示页面的贴入行信息；<br/>⑤ 入账行相关信息为贴现户银行信息；<br/>⑥ 是否行外贴现：除“平安银行网银”外，全部选择“行外贴现”；<br/>注：网银里选择"贴现”而不是“背书”。',
					stepStatus: "other",
				});
				this.code4Param.activeBankOpration = cuData;
			} else {
				this.code4Param.activeBankOpration = this.code4Param.bankOperationList[
					val
				];
			}

			if (index > 4) {
				let cu = this.code4Param.bankList[index];
				// console.log(this.code4Param.bankList, index);
				this.code4Param.bankList.splice(index, 1);
				// console.log(this.code4Param.bankList, index);
				this.code4Param.bankList.unshift(cu);
				// console.log(this.code4Param.bankList, index);
			}

			// console.log(this.code4Param.activeBankCode)
			this.code4Param.moreShowStatus = false;
			this.code4Param.left = 0;
		},
		moveImg: function(val) {
			if (val == "L") {
				if (this.code4Param.left - 381 < 0) {
					this.code4Param.left = 0;
					return false;
				}
				// 向左移动
				this.code4Param.left -= 381;
			} else if (val == "R") {
				// 当贴现步骤的长度大于等于3时进行判断，当贴现步骤的长度等于2时单独进行判断，因为页面的步骤最少三个
				if (this.code4Param.activeBankOpration.length >= 3) {
					if (
						this.code4Param.left + 381 >
						this.code4Param.activeBankOpration.length * 366 -
							988 +
							(this.code4Param.activeBankOpration.length - 1) * 15
					) {
						this.code4Param.left =
							this.code4Param.activeBankOpration.length * 366 -
							988 +
							(this.code4Param.activeBankOpration.length - 1) * 15;
						return false;
					}
					// 向右移动
					this.code4Param.left += 381;
				} else if (this.code4Param.activeBankOpration.length === 2) {
					this.code4Param.left = 3 * 366 - 988 + (3 - 1) * 15;
				}
			}
		},
		tolink() {
			console.log("--this.allParam", this.allParam);
			this.$router.push({
				name: "SilverTicketFinish",
				params: { id: this.allParam.discountData.discountOrderId },
			});
		},

		// 查看大图
		showImg: function(val, index) {
			this.showImgData.showImgStatus = true;
			this.showImgData.showImgUrl = val.imgUrl;
			this.showImgData.content = val.content;
			this.showImgData.stepDes = val.stepDes;
			this.showImgData.index = index;
			this.showImgData.step = this.code4Param.activeBankOpration.length;
		},

		// code-4 || code-5 同步订单信息
		checkOrderInfo: function(JDFlag) {
			this.addLoading();
			this.sendPut(
				{
					url: `/web/discount-order/sync/${
						this.allParam.discountData.discountOrderId
					}`,
				},
				(result) => {
					// 同步订单状态
					Object.assign(
						_this.allParam.discountData,
						this.handleObj(
							["discountSyncOrderJdDto"],
							result.data.data.discountSyncOrderDto
						),
						this.handleObj(["status"], result.data.data)
					);

					// if (JDFlag) {
					// }
					this.isShowJDProcess = true;

					this.handleStatus(result.data.data.status);
					this.removeLoading();
				},
				(err) => {
					console.log(err);
					this.removeLoading();
				}
			);
		},
		getHuarunQrCode() {
			this.sendGet(
				{
					url: `/web/discount-order/getHuarunQrCode/`,
				},
				(result) => {
					console.log("ack回调", result);
					if (result.data) {
						this.showHuarunBankSign.HuarunQrCode = result.data.data;
					}
				},
				(result) => {
					// console.log("其他回调", result);
				}
			);
		},

		handleStatus(status) {
			console.log(this.allParam, status);
			if (status == "0") {
				// 贴现成功
				console.log("贴现成功");
				if (this.allParam.discountData.bankCode === "PINGAN") {
					this.showTip({
						tipMessage:
							"<div class='fb f16'>贴现至平安银行后需准备该笔贴现资金去向的合同发票及流水，<br />以备银行后续查验</div>", // 提示信息
						tipLogo: "tip_prompt", // 提示logo
						tipButtonLeft: "我知道了", // 左按钮名称
						tipButtonLeftType: "default", // 左按钮的类型
						tipButtonLeftCall: function() {
							_this.hidePopus();
						}, // 左按钮回调
						title: "温馨提示", // 顶部title
					});
				}
				this.initCode6();
			} else {
				this.current = 2; // 进度条
			}

			// 进行中 01:正在校验中
			if (status == "10") {
				_this.code = 5;

				// 京东上传贸易背景资料状态处理
				let orderStatus = _this.allParam.discountData.discountSyncOrderJdDto
					? _this.allParam.discountData.discountSyncOrderJdDto.orderStatus
					: "";
				if (orderStatus === "40" || orderStatus === "20") {
					setTimeout(function() {
						_this.code = 3;
					}, 3000);
				} else {
					setTimeout(function() {
						_this.code = 7;
					}, 3000);
				}
			}

			// 贴现失败 03：重新校验和贴现失败
			if (status == "30") {
				_this.code = 7;
			}

			this.removeLoading();
		},

		// code-6 获取贴现凭证
		initCode6() {
			this.code = 6;
			this.current = 3; // 进度条
			// this.getRateInfo()
		},
		getDiscount: function() {
			console.log(this.allParam.discountData, "this.allParam.discountData");
			if (this.allParam.discountData.bankCode === "BAIXIN") {
				// 百信的情况
				// 提示---百信下载贴凭
				this.showTip({
					tipMessage:
						"<div class='f18 c333'>百信银行暂不支持在线获取贴现凭证，<br/>请拨打400-8180100由银行官方为您提供该服务。</div>", // 提示信息
					tipLogo: "tip_prompt", // 提示logo
					tipButtonLeft: "我知道了", // 左按钮名称
					tipButtonLeftType: "primary", // 左按钮的类型
					tipButtonRight: "", // 右按钮名称
					tipButtonRightType: "default", // 右按钮类型
					tipButtonLeftCall: function() {
						_this.hidePopus();
					}, // 左按钮回调
					tipButtonRightCall: function() {
						_this.hidePopus();
					}, // 右按钮回调
					title: "获取贴现凭证", // 顶部title
				});
				return false;
			}
			this.addLoading();
			this.sendGet(
				{
					url: `/web/discount-order/voucher/${
						this.allParam.discountData.discountOrderId
					}`,
				},
				(result) => {
					window.open(result.data.data.url.replace(/&amp;/g, "&"));
				}
			);
		},
		getRateInfo() {
			this.sendGet(
				{
					url: "/web/deposit-rate",
				},
				(res) => {
					this.depositRate = res.data.data.sort((a, b) => {
						return a.minDays - b.minDays;
					});
				}
			);
		},
		electronicEvent() {
			this.addLoading();
			this.sendGet(
				{
					url: "/web/deposit-mth-acct",
					data: { userId: this.$store.state.userId },
				},
				(res) => {
					let data = res.data.data;
					this.result = data.filter((v) => v.status === "SUCCESS");

					if (this.result.length == 0) {
						this.$router.push("/ElectronicDepositAccount");
					} else {
						this.$router.push("/ElectronicDepositList");
					}
				}
			);
		},

		getBnkInfoBg(val) {
			// 获取银行实景图
			let banArr = [
				"WHLH",
				"YNHT",
				"WZ",
				"FUMIN",
				"PINGAN",
				"SANXIANG",
				"HUARUN",
			];

			if (banArr.indexOf(val) == -1) {
				return "";
			} else {
				return require("@/assets/img/bankInfoBg/" + val + ".png");
			}
		},
	},
	// 监听
	watch: {
		allParam: {
			handler: function(nval) {
				this.allParam.userId = this.$store.state.userId;

				if (
					this.allParam.billNo &&
					this.allParam.billAmount &&
					this.allParam.acceptorBankNum &&
					this.allParam.dueDate
				) {
					this.code1Param.nextStatus = true;
				} else {
					this.code1Param.nextStatus = false;
				}

				this.allParam.billAmountSupper = this.digitUppercase(
					this.allParam.billAmount
				);
			},
			deep: true,
		},
	},
	created() {
		_this = this;

		// this.handleTabTrue(); // 判断tab是否可选择

		// 页面跳转传递参数
		if (this.$route.params.id) {
			this.handleDetail(this.$route.params.id); // 请求记录详情
		} else if (this.$route.query.billNo) {
			console.log(this.$route.query, this.allParam);

			this.$set(this.allParam, "acceptorBankNum", this.$route.query.acceptor);
			// this.$set(this.allParam, 'acceptorBankName', .acceptor);

			Object.assign(
				this.allParam,
				this.handleObj(
					["billBase64", "billNo", "billAmount", "dueDate", "dueDays"],
					this.$route.query
				)
			);

			// console.log(this.allParam, this.$route.query, '===================');
			this.allParam.billBase64 ? _this.ocrDiscern() : "";

			this.$router.push(this.$route.path); //再跳转路由路径，query参数没带过去，所以被清除了
		} else if (this.$route.params.isHUARUNFinsh) {
			this.getHuarunQrCode();
			this.code = 6;
			this.current = 4;
			this.isHUARUNFinsh = true;
		} else {
			this.handleBill(); // 初始化票据数据
		}

		// 快贴宝票面识别广告位
		this.getAdvertimg("ktb_bill_ocr", (data) => {
			this.bottomImg = data;
		});

		// 提示--语句--预约签约
		// this.showTip({
		//   tipMessage: "<div class='f18 c333'>平安银行签约以“线下银行柜面签约”形式签约<br/>提交后将由银行专人与您确认签约事宜并在就近网店签约<br/>是否立即预约？</div>", // 提示信息
		//   tipLogo: "tip_banks", // 提示logo
		//   tipButtonLeft: "是，预约柜台签约", // 左按钮名称
		//   tipButtonLeftType: "primary", // 左按钮的类型
		//   tipButtonRight: "暂不预约", // 右按钮名称
		//   tipButtonRightType: "default", // 右按钮类型
		//   tipButtonLeftCall: function () {
		//     _this.hidePopus();
		//   }, // 左按钮回调
		//   tipButtonRightCall: function () {
		//     _this.hidePopus();
		//   }, // 右按钮回调
		//   title: "提示", // 顶部title
		// });

		// 提示---柜台预约
		// this.showTip({
		//   tipMessage: "<div class='f18 c333'>您已于2020-12-12 18:00预约了柜台签约<br/>请耐心等待</div>", // 提示信息
		//   tipLogo: "tip_banks", // 提示logo
		//   tipButtonLeft: "长时间无人联络签约，请点击此处", // 左按钮名称
		//   tipButtonLeftType: "primary", // 左按钮的类型
		//   tipButtonRight: "取消预约", // 右按钮名称
		//   tipButtonRightType: "default", // 右按钮类型
		//   tipButtonLeftCall: function () {
		//     _this.hidePopus();
		//   }, // 左按钮回调
		//   tipButtonRightCall: function () {
		//     _this.hidePopus();
		//   }, // 右按钮回调
		//   title: "柜台预约", // 顶部title
		// });
	},
	mounted: function() {
		this.initBtnCopy(); // 初始化复制

		// 添加
		document.body.onclick = () => {
			_this.code4Param.moreShowStatus = false;
		};

		this.importJdSDK();
		// $(document).click(function () {
		//   _this.code4Param.moreShowStatus = false;
		// });
	},
	destroyed: function() {
		this.myClipboard ? this.myClipboard.destroy() : "";
	},
};
</script>

<style scoped>
.applicationDiscount .upload_img {
	width: 80px;
	height: 58px;
	display: inline-block;
	background: url(~@/assets/img/applicationDiscount/icon_picture@2x.png)
		no-repeat center center;
	background-size: cover;
}
.img_left {
	background: url(~@/assets/img/applicationDiscount/Acceptance_bill_picture@2x.png)
		no-repeat center center;
	background-size: cover;
}
.left_ticket_img1 {
	background-color: #fff5f9;
}
.left_ticket_img1 .title_bg {
	background-color: #ffdada;
}
.right_ticket_img1 {
	background-color: #f5f7fb;
}
.right_ticket_img1 .title_bg {
	background-color: #e5ebf1;
}
.animate {
	transition: all 0.8s ease;
}
.loding_img {
	background: url(/static/img/img_common/loading.gif) no-repeat center center;
	background-size: cover;
}
.top .ivu-table td,
.top .ivu-table th {
	padding-bottom: 0px;
	padding-top: 0px;
	height: 33px;
}
.top {
	margin-top: -10px;
}

/*选择账户*/
.ul-list-active {
	border: 2px solid #e1241a;
	background: url(~@/assets/img/applicationDiscount/Checked_red@2x.png)
		no-repeat right bottom;
	background-size: 45px 26px;
}
.ul-list {
	border: 1px solid #cccccc;
	cursor: pointer;
	background: url(~@/assets/img/applicationDiscount/Checked_gray@2x.png)
		no-repeat right bottom;
	background-size: 45px 26px;
}

/*银行操作指南*/
.bank_tab {
	position: relative;
	top: 10px;
}
.bank_tab_active {
	position: relative;
	top: 10px;
	z-index: 10;
	background: #fff;
	border-radius: 8px;
	border: 1px solid #ccc;
	border-bottom: none;
}

.more_div:before {
	display: block;
	width: 0px;
	height: 0px;
	content: "";
	position: absolute;
	top: -8px;
	left: calc(50% + 25px);
	border-bottom: 7px solid #e9e9e9;
	border-left: 6px solid transparent;
	border-right: 6px solid transparent;
}

.more_div:after {
	display: block;
	width: 0px;
	height: 0px;
	content: "";
	position: absolute;
	top: -6px;
	left: calc(50% + 25px);
	border-bottom: 7px solid #fff;
	border-left: 6px solid transparent;
	border-right: 6px solid transparent;
}

/* 正在加载中 */
.demo-spin-icon-load-position {
	position: absolute;
	top: 8px;
	left: 56px;
}
</style>

<style scoped lang="scss" type="text/css">
@import "@/assets/scss/base.less";
.opt008 {
	opacity: 0.08;
}
.t-27 {
	top: -27px;
}
.r-17 {
	right: -17px;
}
.ce1241a {
	color: #e1241a;
}
.bgF1F5F8 {
	background: #f1f5f8;
}
.electronicBg {
	width: 732px;
	height: 120px;
	background: #f7f7f7;
	border: 1px solid #cccccc;
	margin-top: 46px;
	display: flex;
	justify-content: space-between;
	align-items: center;
	padding: 12px 24px;

	&-left {
		text-align: left;

		.logo {
			display: flex;
			justify-content: flex-start;
			align-items: center;
			line-height: 20px;
			margin-bottom: 11px;

			img {
				display: block;
			}
			span {
				margin-left: 10px;
				margin-right: 10px;
			}
		}
		.rate {
			height: 30px;
		}
	}
}
.huarun_modal {
	/deep/ .ivu-modal-header {
		background: #fff;
		padding: 12px 0;
		p {
			// padding: 4px;
			color: #333;
			font-size: 18px;
			font-weight: bold;
		}
	}
	/deep/.ivu-modal-close {
		/deep/ .ivu-modal-close .ivu-icon-ios-close {
			color: #e1241a !important;
		}
	}
	.step {
		.step-item {
			width: 146px;
			// margin-right: 4px;
			.top {
				display: flex;
				align-items: center;
				.step-node {
					display: inline-block;
					width: 8px;
					height: 8px;
					border-radius: 50%;
					border: 1px solid #ccc;
					margin-right: 4px;
					margin-left: 4px;
				}
				.step-line {
					display: inline-block;
					width: 144px;
					height: 2px;
					background: #e6e6e6;
				}
			}

			.step-node-active {
				background: #e1241a;
				// width: 14px !important;
				// height: 14px !important;
				border: 1px solid #e1241a;
				border: none !important;
				margin: 0 !important;
			}

			.step-line-active {
				background: #e1241a !important;
			}
		}
		.step-text {
			color: #999999;
			font-size: 12px;
			font-weight: 500;
		}
		.step-text-active {
			color: #333 !important;
		}
	}
	.wechat_QR {
		height: 337px;
	}
}
.huarun_modal /deep/ .ivu-modal-close .ivu-icon-ios-close {
	color: #e1241a !important;
	font-weight: bold;
}

/*银行操作指南*/
.bank_new_tab {
}
.bank_new_tab_active {
	z-index: 10;
	background: #fdb9b5;
	border-radius: 2px;
	border-bottom: none;

	span {
		color: #e1241a;
	}
}

.more_div:before {
	display: block;
	width: 0px;
	height: 0px;
	content: "";
	position: absolute;
	top: -8px;
	left: calc(50% + 25px);
	border-bottom: 7px solid #e9e9e9;
	border-left: 6px solid transparent;
	border-right: 6px solid transparent;
}

.more_div:after {
	display: block;
	width: 0px;
	height: 0px;
	content: "";
	position: absolute;
	top: -6px;
	left: calc(50% + 25px);
	border-bottom: 7px solid #fff;
	border-left: 6px solid transparent;
	border-right: 6px solid transparent;
}
.image_fill {
	width: 60px;
	height: 60px;
	background: url(~@/assets/img/applicationDiscount/image_fill.png) no-repeat
		center top;
}
.image_fill_small {
	width: 30px;
	height: 30px;
	background: url(~@/assets/img/applicationDiscount/image_fill_small.png)
		no-repeat center top;
}
.huarun_success {
	width: 30px;
	height: 30px;
	background: url(~@/assets/img/applicationDiscount/icon_small_ddwc.png)
		no-repeat center top;
}
.wechat_fill {
	width: 22px;
	height: 21px;
	background: url(~@/assets/img/applicationDiscount/wechat_fill.png) no-repeat
		center top;
}
.wechat_QR_code_a {
	width: 86px;
	height: 85px;
	background: url(~@/assets/img/applicationDiscount/wechat_QR_code_a.png)
		no-repeat center center;
	background-size: cover;
}
/deep/ .bank_list_ul {
	.ivu-spin-fix {
		position: relative;
		background: transparent;
	}
}

ul li {
	list-style: none;
}

.item_logo_a {
	width: 152px;
	height: 64px;
	margin-right: 50px;
	background: url(~@/assets/img/applicationDiscount/navigation@2x.png) no-repeat
		center top;
	background-size: contain;
	flex: none;
	position: relative;
	top: -8px;
}

/*tab*/
/deep/ .ivu-table-small td {
	height: 34px;
}
/deep/ .ivu-tabs-bar {
	margin-bottom: 0px;

	.ivu-tabs-nav {
		display: flex;

		.ivu-tabs-tab {
			padding: 10px 16px;
		}
		.ivu-tabs-tab:last-child {
			line-height: 46px;
		}
	}
}

$ticketH: 350px;

.ticketStyle {
	.divOcrImg {
		position: relative;
		width: 456px;
		height: $ticketH;
	}

	.ticket_example {
		width: 456px;
		height: $ticketH;
		background: url(~@/assets/img/applicationDiscount/tU_b@2x.png) no-repeat
			center center;
		background-size: cover;
	}

	.right_ticket_img {
		height: $ticketH;
		padding: 30px 40px 0px;
		background: url(~@/assets/img/applicationDiscount/bg_Bill_texture@2x.png)
			no-repeat center center;
		background-size: cover;
	}

	.btnDisable {
		color: #999;
		background-color: #cbcbcb;
	}
	.btnDiscountBg {
		background: linear-gradient(
			232deg,
			rgba(246, 1, 81, 1),
			rgba(96, 0, 255, 1)
		);
		color: #fff;
	}
}

.agreement_bg {
	padding: 10px;
	.agreement {
		width: 105px;
		overflow: hidden;
		display: flex;
		justify-content: center;
		align-items: center;
		img {
			// width: 100%;
			height: 100%;
		}
	}
}
.no_agreement_upload {
	width: 42px;
	height: 56px;
	background: url(~@/assets/img/businessTicketDiscount/wenjian_sc_a.png)
		no-repeat center center;
}
.agreement_upload {
	width: 42px;
	height: 56px;
	background: url(~@/assets/img/businessTicketDiscount/PDF.png) no-repeat center
		center;
}
.agreement_upload_word {
	width: 42px;
	height: 56px;
	background: url(~@/assets/img/businessTicketDiscount/word.png) no-repeat
		center center;
}
.agreement_upload_excel {
	width: 42px;
	height: 56px;
	background: url(~@/assets/img/businessTicketDiscount/Excel.png) no-repeat
		center center;
}
.agreement_upload_file {
	width: 42px;
	height: 56px;
	background: url(~@/assets/img/businessTicketDiscount/tongyong.png) no-repeat
		center center;
}
.invoice_bg {
	width: 100%;
	overflow-x: auto;
	overflow-y: hidden;
	.agreement {
		// width: 124px;
		// height: 201px;
	}
	.invoice-item {
		width: 130px;
		height: 130px;
		padding: 10px;
		border: 1px solid #ccc;
		margin-right: 20px;
		.invoice_upload {
			width: 105px;
			// height: 105px;
			overflow: hidden;
			display: flex;
			justify-content: center;
			align-items: center;
			img {
				// width: 100%;
				height: 100%;
			}
		}
	}

	.invoiceAdd_bg {
		width: 124px;
		// height: 201px;
		margin-right: 20px;
		border: 1px solid #ccc;
		.invoiceAdd_inner {
			width: 105px;
			// height: 105px;
			display: flex;
			justify-content: center;
			align-items: center;
			.invoiceAdd {
				width: 42px;
				height: 48px;
				background: url(~@/assets/img/businessTicketDiscount/wenjian_zhuijia.png)
					no-repeat center center;
				background-size: contain;
			}
		}
	}

	.invoice_btn {
		display: inline-block;
		// width: 60px;
		height: 30px;
		border-radius: 4px;
		border: 1px solid #cbcbcb;
		cursor: pointer;
		background: #fff;
		color: #333;
	}
	.invoice_btn:hover {
		border: 1px solid #e9e9e9;
	}
	.delete_invoice {
		width: 30px;
		// height: 30px;
		display: inline-block;
		background: #fff;
		border-radius: 4px;
		border: 1px solid #cbcbcb;
		display: flex;
		justify-content: center;
		.delete_btn {
			display: inline-block;
			width: 12px;
			height: 14px;
			background: url(~@/assets/img/businessTicketDiscount/icon_shanchu.png)
				no-repeat center center;
		}
	}
	.delete_invoice:hover {
		border: 1px solid #e9e9e9;
	}

	.imgUploadBg {
		width: 42px;
		height: 48px;
		background: url(~@/assets/img/businessTicketDiscount/wenjian_sc_b.png)
			no-repeat center center;
		cursor: pointer;
		background-size: contain;
	}
}
.code2Loading {
	text-align: center;

	p {
		display: inline-block;
	}

	.iconBankKtb,
	.iconBankAll {
		width: 93px;
		height: 93px;
	}

	.iconBankKtb {
		background: url(~@/assets/img/applicationDiscount/logo_ktie_point@2x.png)
			no-repeat center center;
		background-size: contain;
	}
	.iconBankAll {
		background: url(~@/assets/img/applicationDiscount/icon_bank@2x.png)
			no-repeat center center;
		background-size: contain;
	}

	.code2LoadingAnimate {
		margin: -45px 42px 0px;
		width: 9px;
		height: 9px;
		position: relative;
		border-radius: 50%;
		// animation: load-effect 6s 2 linear;
		animation: load-effect 1s infinite linear;
	}

	@keyframes load-effect {
		// 20px 左移  25px 下移   0:模糊距离0，即纯色   3px 外扩   #75B6FF:颜色

		0% {
			box-shadow: -32px 25px 0 3px #75b6ff, -16px 25px 0 0 #75b6ff,
				0 25px 0 0 #75b6ff, 16px 25px 0 0 #75b6ff, 32px 25px 0 0 #75b6ff;
		}
		20% {
			box-shadow: -32px 25px 0 0 #75b6ff, -16px 25px 0 3px #75b6ff,
				0 25px 0 0 #75b6ff, 16px 25px 0 0 #75b6ff, 32px 25px 0 0 #75b6ff;
		}
		40% {
			box-shadow: -32px 25px 0 0 #75b6ff, -16px 25px 0 0 #75b6ff,
				0 25px 0 3px #75b6ff, 16px 25px 0 0 #75b6ff, 32px 25px 0 0 #75b6ff;
		}
		60% {
			box-shadow: -32px 25px 0 0 #75b6ff, -16px 25px 0 0 #75b6ff,
				0 25px 0 0 #75b6ff, 16px 25px 0 3px #75b6ff, 32px 25px 0 0 #75b6ff;
		}
		80% {
			box-shadow: -32px 25px 0 0 #75b6ff, -16px 25px 0 0 #75b6ff,
				0 25px 0 0 #75b6ff, 16px 25px 0 0 #75b6ff, 32px 25px 0 3px #75b6ff;
		}
		100% {
			box-shadow: -32px 25px 0 3px #75b6ff, -16px 25px 0 0 #75b6ff,
				0 25px 0 0 #75b6ff, 16px 25px 0 0 #75b6ff, 32px 25px 0 0 #75b6ff;
		}
	}
}

/* code2 */
.top_img {
	background: #fff url(~@/assets/img/applicationDiscount/bill@2x.png) no-repeat
		center top;
	background-size: contain;
}

.table-img1 {
	background: url(~@/assets/img/applicationDiscount/Pickup@2x.png) no-repeat
		center top;
	background-size: cover;
}

.table-img2 {
	background: url(~@/assets/img/applicationDiscount/Pencil_black_gross_tool@2x.png)
		no-repeat center top;
	background-size: cover;
}

#network {
	/deep/ .ivu-modal-body {
		padding: 0px;
	}

	.networkTip {
		width: 200px;
		padding: 5px 15px 8px 5px;
		margin-bottom: 20px;
	}
	.networkTip:after,
	.networkTip:before {
		border-bottom: 0px solid transparent;
		border-left: 20px solid transparent;
		border-right: 20px solid transparent;
		left: 50%;
		-webkit-transform: translateX(-50%);
		-moz-transform: translateX(-50%);
		-ms-transform: translateX(-50%);
		-o-transform: translateX(-50%);
		transform: translateX(-50%);
	}
	.networkTip:after {
		border-top: 15px solid #fff;
		bottom: -14px;
	}
	.networkTip:before {
		border-top: 15px solid #333;
		bottom: -15px;
	}
}

/*输入框的提示*/
.error_input /deep/ .ivu-input {
	border-color: #ff3b30;
}
.bankInfo {
	.tdl-underline {
		text-decoration-line: underline;
	}
	&:hover {
		.bankInfoPopover {
			display: block;
		}
	}
}
.bankInfoPopover {
	width: 540px;
	min-height: 162px;
	background: #ffffff;
	box-shadow: 0px 0px 12px 0px rgba(0, 0, 0, 0.2);
	position: absolute;
	top: 26px;
	left: -38px;
	display: none;
	border-radius: 8px;
	z-index: 1;
	.bankInfoPopover-top {
		height: 100px;
		padding: 14px;
		margin-bottom: 14px;
	}
	.bankInfoPopover-bottom {
		min-height: 49px;
		background: #fafafa;
		font-size: 12px;
		color: #999;
		border-bottom-left-radius: 8px;
		border-bottom-right-radius: 8px;
	}
	&::before {
		content: "";
		height: 0;
		width: 0;
		border: 4px solid transparent;
		border-bottom: 8px solid #fff;
		box-shadow: 0px -6px 50px 0px rgba(0, 0, 0, 0.1);
		position: absolute;
		top: -12px;
		left: 10px;
	}
}
</style>



// WEBPACK FOOTER //
// src/components/applicationDiscount/ApplicationDiscount.vue